
// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import {
//   Box,
//   Typography,
//   Card,
//   CardMedia,
//   CardContent,
//   Grid,
//   Button,
//   IconButton,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   DialogActions,
//   DialogContentText,
//   TextField,
//   FormControl,
//   Select,
//   MenuItem,
//   InputAdornment,
//   CircularProgress,
//   Tabs,
//   Tab,
// } from '@mui/material';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import HotelIcon from '@mui/icons-material/Hotel';
// import BathtubIcon from '@mui/icons-material/Bathtub';
// import SquareFootIcon from '@mui/icons-material/SquareFoot';
// import CloseIcon from '@mui/icons-material/Close';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import CheckIcon from '@mui/icons-material/Check';
// import LinkIcon from '@mui/icons-material/Link';
// import PhoneIcon from '@mui/icons-material/Phone';
// import EmailIcon from '@mui/icons-material/Email';
// import PersonIcon from '@mui/icons-material/Person';
// import Loader from '../Loader/Loader';
// import { selectUser } from '../Commonlibs/userSlice';

// // Import amenity icons
// import liftIcon from '../assets/applift.png';
// import cctvIcon from '../assets/appctv.png';
// import gymIcon from '../assets/appfit.png';
// import gardenIcon from '../assets/appgarden.png';
// import kidsAreaIcon from '../assets/appkids.png';
// import sportsIcon from '../assets/appsport.png';
// import swimmingPoolIcon from '../assets/appswim.png';
// import intercomIcon from '../assets/appinter.png';
// import gatedCommunityIcon from '../assets/appgate.png';
// import clubHouseIcon from '../assets/appclub.png';
// import communityHallIcon from '../assets/appcom.png';
// import regularWaterSupplyIcon from '../assets/appregul.png';
// import powerBackupIcon from '../assets/apppower.png';
// import petAllowedIcon from '../assets/apppet.png';
// import diningTableIcon from '../assets/appdinner.png';
// import washingMachineIcon from '../assets/appwash.png';
// import sofaIcon from '../assets/appsofa.png';
// import microwaveIcon from '../assets/appmicro.png';
// import fridgeIcon from '../assets/appfridge.png';
// import waterPurifierIcon from '../assets/appwater.png';
// import gasPipelineIcon from '../assets/appgas.png';
// import acIcon from '../assets/appac.png';
// import bedIcon from '../assets/appbed.png';
// import tvIcon from '../assets/apptv.png';
// import cupboardIcon from '../assets/appcup.png';
// import geyserIcon from '../assets/appgeyser.png';

// // Amenities data
// const societyAmenitiesData = [
//   { name: "Lift", icon: liftIcon },
//   { name: "CCTV", icon: cctvIcon },
//   { name: "Gym", icon: gymIcon },
//   { name: "Garden", icon: gardenIcon },
//   { name: "Kids Area", icon: kidsAreaIcon },
//   { name: "Sports", icon: sportsIcon },
//   { name: "Swimming Pool", icon: swimmingPoolIcon },
//   { name: "Intercom", icon: intercomIcon },
//   { name: "Gated Community", icon: gatedCommunityIcon },
//   { name: "Club House", icon: clubHouseIcon },
//   { name: "Community Hall", icon: communityHallIcon },
//   { name: "Regular Water Supply", icon: regularWaterSupplyIcon },
//   { name: "Power backup", icon: powerBackupIcon },
//   { name: "Pet Allowed", icon: petAllowedIcon },
// ];

// const furnishingFacilitiesData = [
//   { name: "Dining Table", icon: diningTableIcon },
//   { name: "Washing Machine", icon: washingMachineIcon },
//   { name: "Sofa", icon: sofaIcon },
//   { name: "Microwave", icon: microwaveIcon },
//   { name: "Fridge", icon: fridgeIcon },
//   { name: "Water Purifier", icon: waterPurifierIcon },
//   { name: "Gas Pipeline", icon: gasPipelineIcon },
//   { name: "AC", icon: acIcon },
//   { name: "Bed", icon: bedIcon },
//   { name: "TV", icon: tvIcon },
//   { name: "Cupboard", icon: cupboardIcon },
//   { name: "Geyser", icon: geyserIcon },
// ];

// const otherFacilitiesData = [
//   "Hospital", "School", "Park", "Shopping Mall",
//   "Metro Station", "Bus Stop", "Restaurant", "Pharmacy"
// ];

// const base64ToFile = async (base64String, filename) => {
//   try {
//     const response = await fetch(base64String);
//     const blob = await response.blob();
//     return new File([blob], filename, { type: blob.type });
//   } catch (error) {
//     console.error('Error converting base64 to file:', error);
//     return null;
//   }
// };

// const EditProperties = () => {
//   const { propertyId } = useParams();
//   const navigate = useNavigate();
//   const user = useSelector(selectUser);

//   const [loading, setLoading] = useState(true);
//   const [property, setProperty] = useState(null);
//   const [error, setError] = useState(null);
//   const [selectedMedia, setSelectedMedia] = useState(null);
//   const [mediaDialogOpen, setMediaDialogOpen] = useState(false);
//   const [mediaType, setMediaType] = useState('image');
//   const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
//   const [editListingDialogOpen, setEditListingDialogOpen] = useState(false);
//   const [amenitiesDialogOpen, setAmenitiesDialogOpen] = useState(false);
//   const [editedProperty, setEditedProperty] = useState(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [imagesToDelete, setImagesToDelete] = useState([]);
//   const [alertDialog, setAlertDialog] = useState({
//     open: false,
//     message: '',
//     severity: 'success'
//   });
//   const [photosDialogOpen, setPhotosDialogOpen] = useState(false);
//   const [uploadedPhotos, setUploadedPhotos] = useState([]);
//   const [isUploading, setIsUploading] = useState(false);
//   const [userProfile, setUserProfile] = useState({
//     full_name: '',
//     email_id: '',
//     contact_number: '',
//     profile_image: null
//   });
//   const [contactDialogOpen, setContactDialogOpen] = useState(false);
//   const [currentTab, setCurrentTab] = useState(0);


//   const validateAlphanumericField = (value, fieldName, isRequired = true) => {
//     if (isRequired && (!value || !value.trim())) return `${fieldName} is required`;
    
//     // Extract only numbers from the value
//     const numbers = value.replace(/\D/g, '');
    
//     // Check if numbers exceed 5 digits
//     if (numbers.length > 5) return `${fieldName} can contain maximum 5 digits`;
    
//     return "";
//   };


//   const hasValue = (value) => {
//     return value !== null && value !== undefined && value !== '';
//   };

//   const shouldShowAmenities = () => {
//     if (!property) return false;
//     const propertyType = property.property_type?.toLowerCase();
//     const assetType = property.asset_type?.toLowerCase();
//     const isFarmhouse = assetType === 'farm house' || assetType === 'farmhouse';
//     const isVilla = assetType === 'villa';
//     const isPlot = assetType === 'plot';
//     const isAgricultureLand = assetType === 'agriculture land';
    
//     // ✅ Show amenities for: Residential (except plot/agriculture) OR Commercial Farmhouse/Villa
//     return (propertyType === 'residential' && !isPlot && !isAgricultureLand) || 
//            (propertyType === 'commercial' && (isFarmhouse || isVilla));
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };

//   const formatCurrency = (amount, currency = '₹') => {
//     if (!amount) return `${currency}0`;
//     return `${currency}${Number(amount).toLocaleString()}`;
//   };

//   const processMedia = (mediaData) => {
//     if (!mediaData || !Array.isArray(mediaData)) return [];

//     return mediaData
//       .map(item => {
//         try {
//           if (typeof item === 'object' && item?.image) {
//             const imageData = item.image.startsWith('data:')
//               ? item.image
//               : `data:image/png;base64,${item.image}`;

//             return {
//               type: 'image',
//               data: imageData,
//               id: item.id || `temp-${Math.random()}`,
//               image_name: item.image_name || 'Property Image'
//             };
//           }
//           return null;
//         } catch (error) {
//           console.error('Error processing media item:', error);
//           return null;
//         }
//       })
//       .filter(item => item !== null);
//   };

//   const getMainImage = (mediaArray) => {
//     if (!mediaArray || mediaArray.length === 0) return null;
//     const firstImage = mediaArray.find(item => item.type === 'image');
//     return firstImage ? firstImage.data : null;
//   };

//   const getAdditionalMedia = (mediaArray) => {
//     if (!mediaArray || mediaArray.length <= 1) return [];
//     return mediaArray.slice(1).slice(0, 3);
//   };

//   const handleMediaOpen = (media, type, index) => {
//     setSelectedMedia(media);
//     setMediaType(type);
//     setCurrentMediaIndex(index !== undefined ? index : 0);
//     setMediaDialogOpen(true);
//   };

//   const handleMediaClose = () => {
//     setMediaDialogOpen(false);
//     setSelectedMedia(null);
//   };

//   const handleNextMedia = (allMedia) => {
//     if (currentMediaIndex < allMedia.length - 1) {
//       const nextIndex = currentMediaIndex + 1;
//       const nextMedia = allMedia[nextIndex];
//       setSelectedMedia(nextMedia.data);
//       setMediaType(nextMedia.type);
//       setCurrentMediaIndex(nextIndex);
//     }
//   };

//   const handlePrevMedia = (allMedia) => {
//     if (currentMediaIndex > 0) {
//       const prevIndex = currentMediaIndex - 1;
//       const prevMedia = allMedia[prevIndex];
//       setSelectedMedia(prevMedia.data);
//       setMediaType(prevMedia.type);
//       setCurrentMediaIndex(prevIndex);
//     }
//   };

//   const handleFileUpload = (event) => {
//     const files = Array.from(event.target.files);

//     if (uploadedPhotos.length + files.length > 10) {
//       setAlertDialog({
//         open: true,
//         message: `You can only upload a maximum of 10 images. Currently you have ${uploadedPhotos.length} images.`,
//         severity: 'error'
//       });
//       return;
//     }

//     const validImages = files.filter(file => file.type.startsWith('image/'));

//     if (validImages.length !== files.length) {
//       setAlertDialog({
//         open: true,
//         message: 'Some files were skipped (invalid image type)',
//         severity: 'warning'
//       });
//     }

//     validImages.forEach(file => {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const newMedia = {
//           id: `temp-${Date.now()}-${Math.random()}`,
//           name: file.name,
//           size: file.size,
//           type: 'image',
//           preview: e.target.result,
//           file: file,
//           isNew: true
//         };
//         setUploadedPhotos(prev => [...prev, newMedia]);
//       };
//       reader.onerror = (error) => {
//         console.error('Error reading file:', error);
//         setAlertDialog({
//           open: true,
//           message: `Failed to read file: ${file.name}`,
//           severity: 'error'
//         });
//       };
//       reader.readAsDataURL(file);
//     });

//     event.target.value = '';
//   };

//   const handleDeleteMedia = (id) => {
//     const photoToDelete = uploadedPhotos.find(item => item.id === id);

//     if (photoToDelete && !photoToDelete.isNew) {
//       setImagesToDelete(prev => [...prev, id]);
//     }

//     setUploadedPhotos(prev => prev.filter(item => item.id !== id));
//   };

//   const handleSaveMedia = async () => {
//     setIsUploading(true);

//     try {
//       if (imagesToDelete.length > 0) {
//         for (const imageId of imagesToDelete) {
//           try {
//             const deletePayload = {
//               property_id: property?.id,
//               seller_id: user?.id || property?.seller_id,
//               image_id: imageId
//             };

//             const deleteResponse = await fetch('https://propertydealstalk.com/api/property/removePropertyImage', {
//               method: 'POST',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify(deletePayload)
//             });

//             const deleteData = await deleteResponse.json();

//             if (deleteData.status !== "SUCCESS") {
//               console.warn(`Failed to delete image ${imageId}:`, deleteData.message);
//             }
//           } catch (deleteError) {
//             console.error(`Error deleting image ${imageId}:`, deleteError);
//           }
//         }

//         setImagesToDelete([]);
//       }

//       const newPhotos = uploadedPhotos.filter(photo => photo.isNew && photo.file);

//       if (newPhotos.length > 0) {
//         const formData = new FormData();
//         formData.append('property_id', String(property?.id));
//         formData.append('seller_id', String(user?.id || property?.seller_id));

//         newPhotos.forEach((photo) => {
//           formData.append('property_images', photo.file, photo.file.name);
//         });

//         const response = await fetch('https://propertydealstalk.com/api/property/updateProperty', {
//           method: 'POST',
//           body: formData,
//         });

//         const responseText = await response.text();

//         let data;
//         try {
//           data = JSON.parse(responseText);
//         } catch (parseError) {
//           throw new Error(`Server returned invalid response: ${responseText.substring(0, 200)}`);
//         }

//         if (!response.ok || data.status !== "SUCCESS") {
//           throw new Error(data.message || 'Failed to upload images');
//         }
//       }

//       const refreshResponse = await fetch(`https://propertydealstalk.com/api/property/getProperties?property_id=${property?.id}&timestamp=${Date.now()}`);
//       const refreshData = await refreshResponse.json();

//       if (refreshData.status === "SUCCESS") {
//         const propertyData = Array.isArray(refreshData.result) ? refreshData.result[0] : refreshData.result;
//         setProperty(propertyData);

//         const allMedia = processMedia(propertyData?.images || []);
//         const photos = allMedia.filter(item => item.type === 'image').map(item => ({
//           id: item.id,
//           name: item.image_name || 'Property Image',
//           preview: item.data,
//           type: 'image',
//           isNew: false
//         }));
//         setUploadedPhotos(photos);
//       }

//       setPhotosDialogOpen(false);

//       const deletedCount = imagesToDelete.length;
//       const uploadedCount = newPhotos.length;
//       let message = '';

//       if (deletedCount > 0 && uploadedCount > 0) {
//         message = `Deleted ${deletedCount} image(s) and uploaded ${uploadedCount} new image(s)!`;
//       } else if (deletedCount > 0) {
//         message = `Successfully deleted ${deletedCount} image(s)!`;
//       } else if (uploadedCount > 0) {
//         message = `Successfully uploaded ${uploadedCount} new image(s)!`;
//       } else {
//         message = 'No changes made';
//       }

//       setAlertDialog({
//         open: true,
//         message: message,
//         severity: 'success'
//       });
//     } catch (error) {
//       console.error('=== Save Media Error ===');
//       console.error('Error:', error);
//       setAlertDialog({
//         open: true,
//         message: `Failed to save changes: ${error.message}`,
//         severity: 'error'
//       });
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchPropertyDetails = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}`);
//         const data = await response.json();

//         if (data.status === "SUCCESS") {
//           const propertyData = Array.isArray(data.result) ? data.result[0] : data.result;

//           if (propertyData) {
//             setProperty(propertyData);
//             setEditedProperty(propertyData);
//           } else {
//             setError('Property not found');
//           }
//         } else {
//           setError('Failed to fetch property details');
//         }
//       } catch (error) {
//         setError('Error fetching property details');
//         console.error('Error fetching property details:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (propertyId) {
//       fetchPropertyDetails();
//     }
//   }, [propertyId]);

//   useEffect(() => {
//     const fetchUserProfile = async () => {
//       try {
//         if (!user?.id) return;

//         const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${user.id}`);
//         const data = await response.json();

//         if (data.status === "SUCCESS") {
//           setUserProfile({
//             full_name: data.result.full_name || '',
//             email_id: data.result.email_id || '',
//             contact_number: data.result.contact_number || '',
//             profile_image: data.result.profile_image || null
//           });
//         }
//       } catch (err) {
//         console.error('Error fetching user profile:', err);
//       }
//     };

//     fetchUserProfile();
//   }, [user?.id]);

//   const handleEditProperty = (section) => {
//     if (section === 'listing') {
//       setCurrentTab(0);
//       setEditListingDialogOpen(true);
//     } else if (section === 'amenities') {
//       if (!shouldShowAmenities()) {
//         setAlertDialog({
//           open: true,
//           message: 'Amenities are not applicable for this property type',
//           severity: 'error'
//         });
//         return;
//       }
//       setAmenitiesDialogOpen(true);
//     } else if (section === 'photos') {
//       setPhotosDialogOpen(true);

//       const allMedia = processMedia(property?.images || []);
//       const photos = allMedia.filter(item => item.type === 'image').map(item => ({
//         id: item.id,
//         name: item.image_name || 'Property Image',
//         preview: item.data,
//         type: 'image',
//         isNew: false
//       }));
//       setUploadedPhotos(photos);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditedProperty(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSaveChanges = async (dialogType) => {
//     try {
//       setIsSaving(true);

//       const payload = {
//         property_id: editedProperty?.id,
//         seller_id: user?.id || editedProperty?.seller_id || 1,
//       };

//       if (dialogType === 'listing') {
//         const numericFields = [
//           'asking_price', 'property_size', 'bhk', 'bathrooms',
//           'total_floors', 'select_floor',
//           'monthly_rent', 'carpet_area', 'built_up_area', 'uds',
//           'length', 'width'
//         ];

//         const fieldsToCheck = [
//           'property_name', 'location', 'area_name', 'asking_price',
//           'currency', 'property_size', 'property_size_units', 'bhk',
//           'bathrooms', 'description', 'total_floors', 'select_floor',
//           'furnish_type', 'negotiable',
//           'construction_status', 'full_address', 'youtube_link',
//           'carpet_area', 'carpet_area_units', 'built_up_area',
//           'built_up_area_units', 'uds', 'uds_units', 'monthly_rent', 'security_deposit',
//           'available_from', 'length', 'width', 'ownership',
//           'commercial_catgory', 'commercial_asset_type', 'hub', 'landmark',
//           'locality', 'length_units', 'width_units', 'zone_type'
//         ];

//         fieldsToCheck.forEach(field => {
//           if (editedProperty?.[field] !== undefined &&
//             editedProperty?.[field] !== null &&
//             editedProperty?.[field] !== '') {
//             if (numericFields.includes(field)) {
//               const numValue = Number(editedProperty[field]);
//               if (!isNaN(numValue)) {
//                 payload[field] = numValue;
//               }
//             } else if (field === 'negotiable') {
//               payload[field] = editedProperty[field] === 'true' || editedProperty[field] === true;
//             } else {
//               payload[field] = editedProperty[field];
//             }
//           }
//         });
//       } else if (dialogType === 'amenities') {
//         if (!shouldShowAmenities()) {
//           setAlertDialog({
//             open: true,
//             message: 'Amenities are not applicable for this property type',
//             severity: 'error'
//           });
//           setIsSaving(false);
//           return;
//         }

//         payload.society_aminities = editedProperty?.society_aminities || '';
//         payload.furnish_facilities = editedProperty?.furnish_facilities || '';
//         payload.other_facilities = editedProperty?.other_facilities || '';
//       }

//       const response = await fetch('https://propertydealstalk.com/api/property/updateProperty', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload)
//       });

//       const data = await response.json();

//       if (data.status === "SUCCESS") {
//         const refreshResponse = await fetch(`https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}&timestamp=${new Date().getTime()}`);
//         const refreshData = await refreshResponse.json();

//         if (refreshData.status === "SUCCESS") {
//           const propertyData = Array.isArray(refreshData.result) ? refreshData.result[0] : refreshData.result;
//           setProperty(propertyData);
//           setEditedProperty(propertyData);
//         }

//         if (dialogType === 'listing') {
//           setEditListingDialogOpen(false);
//         } else if (dialogType === 'amenities') {
//           setAmenitiesDialogOpen(false);
//         }

//         setAlertDialog({
//           open: true,
//           message: 'Property updated successfully!',
//           severity: 'success'
//         });
//       } else {
//         throw new Error(data.message || 'Failed to update property');
//       }
//     } catch (error) {
//       console.error('Error updating property:', error);
//       setAlertDialog({
//         open: true,
//         message: error.message || 'Failed to update property. Please try again.',
//         severity: 'error'
//       });
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const handleAlertClose = () => {
//     setAlertDialog(prev => ({ ...prev, open: false }));
//   };

//   const getPropertyTypeInfo = () => {
//     const assetType = property?.asset_type?.toLowerCase() || '';
//     const propertyType = property?.property_type?.toLowerCase() || '';
    
//     return {
//       isPlot: assetType === 'plot',
//       isAgricultureLand: assetType === 'agriculture land',
//       isFarmhouse: assetType === 'farm house' || assetType === 'farmhouse',
//       isApartment: assetType === 'apartment',
//       isIndependentHouse: assetType === 'independent house',
//       isPentHouse: assetType === 'pent house' || assetType === 'penthouse',
//       isStudio: assetType === 'studio',
//       isVilla: assetType === 'villa',
//       isCommercial: propertyType === 'commercial',
//       isResidential: propertyType === 'residential',
//       isRent: property?.category?.toLowerCase() === 'rent',
//       isSale: property?.category?.toLowerCase() === 'sale' || property?.category?.toLowerCase() === 'sell',
//       isOffice: assetType === 'office',
//       isShowroom: assetType === 'showroom',
//       isRetailShop: assetType === 'retail shop',
//       isWarehouse: assetType === 'warehouse'
//     };
//   };

//   if (loading) return <Loader />;

//   if (error) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', flexDirection: 'column' }}>
//         <Typography variant="h6" color="error" gutterBottom>
//           {error}
//         </Typography>
//         <Button variant="contained" onClick={() => navigate('/sell-properties')}>
//           Back to Properties
//         </Button>
//       </Box>
//     );
//   }

//   if (!property || !editedProperty) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', flexDirection: 'column' }}>
//         <Typography variant="h6" gutterBottom>
//           Property not found
//         </Typography>
//         <Button variant="contained" onClick={() => navigate('/sell-properties')}>
//           Back to Properties
//         </Button>
//       </Box>
//     );
//   }

//   const allMedia = processMedia(property?.images || []);
//   const mainImageSrc = getMainImage(allMedia);
//   const additionalMedia = getAdditionalMedia(allMedia);
//   const remainingMediaCount = allMedia.length - 4 > 0 ? allMedia.length - 4 : 0;

//   const calculateBuiltYear = () => {
//     if (!hasValue(property?.age_of_property)) return null;
//     const age = Number(property.age_of_property);
//     if (isNaN(age) || age < 0 || age > 100) return null;
//     return new Date().getFullYear() - age;
//   };

//   const propertyData = {
//     id: property?.id,
//     price: property?.category === 'rent' && hasValue(property?.monthly_rent)
//       ? formatCurrency(property.monthly_rent, property.currency) + '/month'
//       : formatCurrency(property?.asking_price, property?.currency),
//     title: property?.property_name || '',
//     location: `${property?.area_name || ''}, ${property?.location || ''}`,
//     date: formatDate(property?.createdAt),
//     views: property?.views || 0,
//     beds: property?.bhk || 0,
//     baths: property?.bathrooms || 0,
//     area: `${property?.property_size || 0} ${property?.property_size_units || ''}`,
//     mainImage: mainImageSrc,
//     additionalMedia: additionalMedia,
//     description: property?.description || 'This property is currently under verification. Update the description to provide more details about your property.',
//     propertyType: `${property?.property_type || ''} - ${property?.asset_type || ''}`,
//     propertyID: `#PD${(property?.id || 0).toString().padStart(6, '0')}`,
//     builtYear: calculateBuiltYear(),
//     status: property?.status,
//     seller: property?.seller || {
//       full_name: 'Owner',
//       email_id: 'N/A',
//       contact_number: 'N/A'
//     }
//   };

//   const typeInfo = getPropertyTypeInfo();

//   return (
//     <>
//       {/* Property Display Card */}
//       <Card sx={{
//         width: '100%',
//         maxWidth: '100%',
//         borderRadius: 2,
//         boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//         overflow: 'hidden',
//         mb: 3,
//         marginTop: { xs: '30px', md: '5px' },
//       }}>
//         <Box sx={{
//           display: 'flex',
//           flexDirection: { xs: 'column', md: 'row' },
//           height: { xs: 'auto', md: '300px' }
//         }}>
//           <Box sx={{
//             width: { xs: '100%', md: '70%' },
//             height: { xs: '200px', md: '100%' },
//             position: 'relative',
//             cursor: propertyData.mainImage ? 'pointer' : 'default',
//             bgcolor: '#f0f0f0',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center'
//           }}
//             onClick={() => propertyData.mainImage && handleMediaOpen(propertyData.mainImage, 'image', 0)}>
//             {propertyData.mainImage ? (
//               <CardMedia
//                 component="img"
//                 sx={{
//                   height: '100%',
//                   width: '100%',
//                   objectFit: 'cover',
//                 }}
//                 image={propertyData.mainImage}
//                 alt={propertyData.title}
//               />
//             ) : (
//               <Typography variant="body1" color="text.secondary">
//                 No Media
//               </Typography>
//             )}
//             {allMedia.length > 0 && (
//               <Box sx={{
//                 position: 'absolute',
//                 bottom: 10,
//                 right: 10,
//                 bgcolor: 'rgba(0,0,0,0.6)',
//                 color: 'white',
//                 px: 1,
//                 py: 0.5,
//                 borderRadius: 1,
//                 fontSize: '0.75rem'
//               }}>
//                 1/{allMedia.length}
//               </Box>
//             )}
//             <Button
//               variant="contained"
//               size="small"
//               sx={{
//                 position: 'absolute',
//                 top: 10,
//                 right: 10,
//                 bgcolor: 'rgba(0,0,0,0.7)',
//                 color: 'white',
//                 borderRadius: 1,
//                 textTransform: 'none',
//                 '&:hover': {
//                   bgcolor: 'rgba(0,0,0,0.8)',
//                 }
//               }}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleEditProperty('photos');
//               }}
//             >
//               Manage Photos
//             </Button>
//             {propertyData.status && (
//               <Box sx={{
//                 position: 'absolute',
//                 top: 10,
//                 left: 10,
//                 backgroundColor: propertyData.status === 'active' ? '#10b981' :
//                   propertyData.status === 'under_verification' ? '#f59e0b' : 'rgba(0,0,0,0.7)',
//                 color: 'white',
//                 padding: '4px 10px',
//                 borderRadius: '4px',
//                 fontSize: '12px',
//                 fontWeight: 500,
//                 textTransform: 'capitalize'
//               }}>
//                 {propertyData.status.replace(/_/g, ' ')}
//               </Box>
//             )}
//           </Box>
//           <Box sx={{
//             width: { xs: '100%', md: '30%' },
//             height: { xs: 'auto', md: '100%' },
//             display: 'flex',
//             flexDirection: { xs: 'row', md: 'column' },
//           }}>
//             {propertyData.additionalMedia.length > 0 ? (
//               propertyData.additionalMedia.map((media, index) => (
//                 <Box
//                   key={media.id || index}
//                   sx={{
//                     flex: 1,
//                     overflow: 'hidden',
//                     borderLeft: { xs: 'none', md: '2px solid white' },
//                     borderBottom: {
//                       xs: 'none',
//                       md: index !== propertyData.additionalMedia.length - 1 ? '2px solid white' : 'none'
//                     },
//                     borderRight: {
//                       xs: index !== propertyData.additionalMedia.length - 1 ? '2px solid white' : 'none',
//                       md: 'none'
//                     },
//                     height: { xs: '100px', md: 'auto' },
//                     position: 'relative',
//                     cursor: 'pointer'
//                   }}
//                   onClick={() => handleMediaOpen(media.data, media.type, index + 1)}
//                 >
//                   <CardMedia
//                     component="img"
//                     image={media.data}
//                     alt={`Property view ${index + 2}`}
//                     sx={{
//                       height: '100%',
//                       width: '100%',
//                       objectFit: 'cover'
//                     }}
//                   />
//                   {index === 2 && remainingMediaCount > 0 && (
//                     <Box sx={{
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       right: 0,
//                       bottom: 0,
//                       backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       color: 'white',
//                       fontWeight: 'bold',
//                       fontSize: '1.5rem'
//                     }}>
//                       +{remainingMediaCount}
//                     </Box>
//                   )}
//                 </Box>
//               ))
//             ) : (
//               Array.from({ length: 3 }).map((_, index) => (
//                 <Box
//                   key={`empty-${index}`}
//                   sx={{
//                     flex: 1,
//                     backgroundColor: '#f0f0f0',
//                     borderLeft: { xs: 'none', md: '2px solid white' },
//                     borderBottom: {
//                       xs: 'none',
//                       md: index !== 2 ? '2px solid white' : 'none'
//                     },
//                     borderRight: {
//                       xs: index !== 2 ? '2px solid white' : 'none',
//                       md: 'none'
//                     },
//                     height: { xs: '100px', md: 'auto' },
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center'
//                   }}
//                 >
//                   <Typography variant="caption" color="text.secondary">
//                     No Media
//                   </Typography>
//                 </Box>
//               ))
//             )}
//           </Box>
//         </Box>

//         <CardContent sx={{ p: 2 }}>
//           <Box sx={{
//   display: 'flex',
//   justifyContent: 'space-between',
//   alignItems: 'center',
//   mb: 1
// }}>
//   <Typography variant="h5" component="div" sx={{
//     fontWeight: '600',
//     color: '#3366CC',
//     fontFamily: 'Outfit'
//   }}>
//     {propertyData.price}
//   </Typography>
//   <Box sx={{ 
//     display: 'flex', 
//     flexDirection: { xs: 'column', sm: 'row' }, // Stack vertically on mobile, horizontal on larger screens
//     gap: 1 
//   }}>
//     <Button
//       variant="outlined"
//       startIcon={<PersonIcon sx={{ fontSize: { xs: 16, sm: 20 } }} />}
//       onClick={() => setContactDialogOpen(true)}
//       sx={{
//         borderRadius: 2,
//         textTransform: 'none',
//         px: { xs: 1.5, sm: 2 },
//         py: { xs: 0.4, sm: 0.5 },
//         fontSize: { xs: '0.75rem', sm: '0.875rem' },
//         fontFamily: 'Outfit',
//         borderColor: '#4285F4',
//         color: '#4285F4',
//         minWidth: { xs: '120px', sm: 'auto' },
//         '&:hover': {
//           borderColor: '#3367d6',
//           backgroundColor: 'rgba(66, 133, 244, 0.04)'
//         }
//       }}
//     >
//       Contact
//     </Button>
//     <Button
//       variant="contained"
//       onClick={() => handleEditProperty('listing')}
//       sx={{
//         bgcolor: '#4285F4',
//         borderRadius: 2,
//         textTransform: 'none',
//         px: { xs: 1.5, sm: 2 },
//         py: { xs: 0.4, sm: 0.5 },
//         fontSize: { xs: '0.75rem', sm: '0.875rem' },
//         fontFamily: 'Outfit',
//         minWidth: { xs: '120px', sm: 'auto' },
//         '&:hover': {
//           bgcolor: '#3367d6'
//         }
//       }}
//     >
//       Edit Listing
//     </Button>
//   </Box>
// </Box>

//           <Typography variant="h6" component="div" sx={{
//             fontWeight: '500',
//             mb: 1,
//             fontFamily: 'Outfit'
//           }}>
//             {propertyData.title}
//           </Typography>

//           <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//             <LocationOnIcon sx={{
//               color: 'text.secondary',
//               fontSize: 18,
//               mr: 0.5,
//               fontWeight: '400'
//             }} />
//             <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
//               {propertyData.location}
//             </Typography>
//           </Box>

//           <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', mr: 3 }}>
//               <CalendarTodayIcon sx={{
//                 color: 'text.secondary',
//                 fontSize: 18,
//                 mr: 0.5,
//                 fontWeight: '400'
//               }} />
//               <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
//                 {propertyData.date}
//               </Typography>
//             </Box>
//             {propertyData.views > 0 && (
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <VisibilityIcon sx={{
//                   color: 'text.secondary',
//                   fontSize: 18,
//                   mr: 0.5,
//                   fontWeight: '400'
//                 }} />
//                 <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
//                   {propertyData.views} {propertyData.views === 1 ? 'View' : 'Views'}
//                 </Typography>
//               </Box>
//             )}
//           </Box>

//           <Grid container spacing={2}>
//             {hasValue(property?.bhk) && (
//               <Grid item xs={4}>
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <HotelIcon sx={{
//                     color: 'text.secondary',
//                     fontSize: 20,
//                     mr: 1,
//                     fontWeight: '400'
//                   }} />
//                   <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
//                     {propertyData.beds} Beds
//                   </Typography>
//                 </Box>
//               </Grid>
//             )}
//             {hasValue(property?.bathrooms) && (
//               <Grid item xs={4}>
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <BathtubIcon sx={{
//                     color: 'text.secondary',
//                     fontSize: 20,
//                     mr: 1,
//                     fontWeight: '400'
//                   }} />
//                   <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
//                     {propertyData.baths} Baths
//                   </Typography>
//                 </Box>
//               </Grid>
//             )}
//             {hasValue(property?.property_size) && (
//               <Grid item xs={4}>
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <SquareFootIcon sx={{
//                     color: 'text.secondary',
//                     fontSize: 20,
//                     mr: 1,
//                     fontWeight: '400'
//                   }} />
//                   <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
//                     {propertyData.area}
//                   </Typography>
//                 </Box>
//               </Grid>
//             )}
//           </Grid>

//           {hasValue(property?.description) && (
//             <Box sx={{ mt: 3 }}>
//               <Typography variant="h6" component="div" sx={{
//                 fontWeight: '500',
//                 mb: 2,
//                 fontFamily: 'Outfit'
//               }}>
//                 Property Description
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{
//                 mb: 3,
//                 fontFamily: 'Outfit'
//               }}>
//                 {propertyData.description}
//               </Typography>
//             </Box>
//           )}

//           {hasValue(property?.full_address) && (
//             <Box sx={{ mt: 3 }}>
//               <Typography variant="h6" component="div" sx={{
//                 fontWeight: '500',
//                 mb: 2,
//                 fontFamily: 'Outfit'
//               }}>
//                 Complete Address
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{
//                 mb: 3,
//                 fontFamily: 'Outfit'
//               }}>
//                 {property.full_address}
//               </Typography>
//             </Box>
//           )}

//           {hasValue(property?.youtube_link) && (
//             <Box sx={{ mt: 3 }}>
//               <Typography variant="h6" component="div" sx={{
//                 fontWeight: '500',
//                 mb: 2,
//                 fontFamily: 'Outfit'
//               }}>
//                 Social Media Link
//               </Typography>
//               <Typography variant="body2" sx={{ fontFamily: 'Outfit' }}>
//                 <a
//                   href={property.youtube_link}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   style={{
//                     color: '#4285F4',
//                     textDecoration: 'none',
//                     fontFamily: 'Outfit'
//                   }}
//                 >
//                   {property.youtube_link}
//                 </a>
//               </Typography>
//             </Box>
//           )}

//           {/* Area Details Section */}
//           {(typeInfo.isApartment || typeInfo.isIndependentHouse || typeInfo.isFarmhouse) && 
//            (hasValue(property?.carpet_area) || hasValue(property?.built_up_area) || hasValue(property?.uds)) && (
//             <Box sx={{ mt: 3 }}>
//               <Typography variant="h6" component="div" sx={{
//                 fontWeight: '500',
//                 mb: 2,
//                 fontFamily: 'Outfit'
//               }}>
//                 Area Details
//               </Typography>
//               <Grid container spacing={2}>
//                 {hasValue(property?.carpet_area) && (
//                   <Grid item xs={12} md={4}>
//                     <Box sx={{
//                       p: 2,
//                       bgcolor: '#f8f9fa',
//                       borderRadius: 2,
//                       border: '1px solid #e0e0e0'
//                     }}>
//                       <Typography variant="body2" color="text.secondary" sx={{
//                         mb: 0.5,
//                         fontFamily: 'Outfit'
//                       }}>
//                         Carpet Area
//                       </Typography>
//                       <Typography variant="h6" sx={{
//                         fontWeight: '500',
//                         fontFamily: 'Outfit'
//                       }}>
//                         {property.carpet_area} {property.carpet_area_units}
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 )}
//                 {hasValue(property?.built_up_area) && (
//                   <Grid item xs={12} md={4}>
//                     <Box sx={{
//                       p: 2,
//                       bgcolor: '#f8f9fa',
//                       borderRadius: 2,
//                       border: '1px solid #e0e0e0'
//                     }}>
//                       <Typography variant="body2" color="text.secondary" sx={{
//                         mb: 0.5,
//                         fontFamily: 'Outfit'
//                       }}>
//                         Built-up Area
//                       </Typography>
//                       <Typography variant="h6" sx={{
//                         fontWeight: '500',
//                         fontFamily: 'Outfit'
//                       }}>
//                         {property.built_up_area} {property.built_up_area_units}
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 )}
//                 {hasValue(property?.uds) && (
//                   <Grid item xs={12} md={4}>
//                     <Box sx={{
//                       p: 2,
//                       bgcolor: '#f8f9fa',
//                       borderRadius: 2,
//                       border: '1px solid #e0e0e0'
//                     }}>
//                       <Typography variant="body2" color="text.secondary" sx={{
//                         mb: 0.5,
//                         fontFamily: 'Outfit'
//                       }}>
//                         UDS (Undivided Share)
//                       </Typography>
//                       <Typography variant="h6" sx={{
//                         fontWeight: '500',
//                         fontFamily: 'Outfit'
//                       }}>
//                         {property.uds} {property.uds_units || 'Sq.Yards'}
//                       </Typography>
//                     </Box>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>
//           )}

//           {/* Features & Amenities */}
//           {shouldShowAmenities() && (
//             <Box sx={{ mt: 3 }}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                 <Typography variant="h6" component="div" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
//                   Features & Amenities
//                 </Typography>
//                 <Button
//                   variant="contained"
//                   onClick={() => handleEditProperty('amenities')}
//                   sx={{
//                     bgcolor: '#4285F4',
//                     borderRadius: 2,
//                     textTransform: 'none',
//                     px: 2,
//                     py: 0.5,
//                     fontSize: '0.875rem',
//                     fontFamily: 'Outfit'
//                   }}
//                 >
//                   Manage Amenities
//                 </Button>
//               </Box>

//               <Box sx={{ mt: 2 }}>
//                 {property?.society_aminities && (
//                   <Box sx={{ mb: 3 }}>
//                     <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 1.5, color: '#333' }}>
//                       Society Amenities
//                     </Typography>
//                     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                       {property.society_aminities.split(', ').filter(item => item).map((amenity, idx) => {
//                         const amenityData = societyAmenitiesData.find(a => a.name === amenity);
//                         return (
//                           <Box
//                             key={idx}
//                             sx={{
//                               display: 'flex',
//                               alignItems: 'center',
//                               gap: 0.5,
//                               px: 1.5,
//                               py: 0.75,
//                               border: '1px solid #e0e0e0',
//                               borderRadius: 1,
//                               backgroundColor: 'transparent'
//                             }}
//                           >
//                             {amenityData && (
//                               <Box
//                                 component="img"
//                                 src={amenityData.icon}
//                                 alt={amenity}
//                                 sx={{
//                                   width: 18,
//                                   height: 18,
//                                   objectFit: 'contain'
//                                 }}
//                               />
//                             )}
//                             <Typography sx={{
//                               fontFamily: 'Outfit',
//                               fontSize: '13px',
//                               color: '#333',
//                               fontWeight: 500
//                             }}>
//                               {amenity}
//                             </Typography>
//                           </Box>
//                         );
//                       })}
//                     </Box>
//                   </Box>
//                 )}

//                 {property?.furnish_facilities && (
//                   <Box sx={{ mb: 3 }}>
//                     <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 1.5, color: '#333' }}>
//                       Furnishing Facilities
//                     </Typography>
//                     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                       {property.furnish_facilities.split(', ').filter(item => item).map((facility, idx) => {
//                         const facilityData = furnishingFacilitiesData.find(f => f.name === facility);
//                         return (
//                           <Box
//                             key={idx}
//                             sx={{
//                               display: 'flex',
//                               alignItems: 'center',
//                               gap: 0.5,
//                               px: 1.5,
//                               py: 0.75,
//                               border: '1px solid #e0e0e0',
//                               borderRadius: 1,
//                               backgroundColor: 'transparent'
//                             }}
//                           >
//                             {facilityData && (
//                               <Box
//                                 component="img"
//                                 src={facilityData.icon}
//                                 alt={facility}
//                                 sx={{
//                                   width: 18,
//                                   height: 18,
//                                   objectFit: 'contain'
//                                 }}
//                               />
//                             )}
//                             <Typography sx={{
//                               fontFamily: 'Outfit',
//                               fontSize: '13px',
//                               color: '#333',
//                               fontWeight: 500
//                             }}>
//                               {facility}
//                             </Typography>
//                           </Box>
//                         );
//                       })}
//                     </Box>
//                   </Box>
//                 )}

//                 {property?.other_facilities && (
//                   <Box>
//                     <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 1.5, color: '#333' }}>
//                       Other Facilities
//                     </Typography>
//                     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                       {property.other_facilities.split(', ').filter(item => item).map((facility, idx) => (
//                         <Box
//                           key={idx}
//                           sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             px: 1.5,
//                             py: 0.75,
//                             border: '1px solid #e0e0e0',
//                             borderRadius: 1,
//                             backgroundColor: 'transparent'
//                           }}
//                         >
//                           <Typography sx={{
//                             fontFamily: 'Outfit',
//                             fontSize: '13px',
//                             color: '#333',
//                             fontWeight: 500
//                           }}>
//                             {facility}
//                           </Typography>
//                         </Box>
//                       ))}
//                     </Box>
//                   </Box>
//                 )}
//               </Box>
//             </Box>
//           )}

//           {/* Additional Details - Horizontal Layout */}
//           <Box sx={{ mt: 3 }}>
//             <Typography variant="h6" component="div" sx={{
//               fontWeight: '500',
//               mb: 2,
//               fontFamily: 'Outfit'
//             }}>
//               Additional details
//             </Typography>
//             <Box sx={{
//               p: 2,
//               bgcolor: '#fafafa',
//               borderRadius: 2,
//               border: '1px solid #e0e0e0'
//             }}>
//               <Grid container spacing={5}>
//                 <Grid item xs={6} sm={4} md={3}>
//                   <Typography variant="body2" color="text.secondary" sx={{
//                     fontFamily: 'Outfit',
//                     fontSize: '12px',
//                     mb: 0.5
//                   }}>
//                     Property type
//                   </Typography>
//                   <Typography variant="body2" sx={{
//                     fontWeight: '500',
//                     fontFamily: 'Outfit',
//                     fontSize: '13px'
//                   }}>
//                     {propertyData.propertyType}
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={6} sm={4} md={3}>
//                   <Typography variant="body2" color="text.secondary" sx={{
//                     fontFamily: 'Outfit',
//                     fontSize: '12px',
//                     mb: 0.5
//                   }}>
//                     Property ID
//                   </Typography>
//                   <Typography variant="body2" sx={{
//                     fontWeight: '500',
//                     fontFamily: 'Outfit',
//                     fontSize: '13px'
//                   }}>
//                     {propertyData.propertyID}
//                   </Typography>
//                 </Grid>

//                 {hasValue(property?.negotiable) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Price Negotiable
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                       textTransform: 'capitalize'
//                     }}>
//                       {property.negotiable === 'true' || property.negotiable === true ? 'Yes' : 'No'}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.construction_status) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Construction Status
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                       textTransform: 'capitalize'
//                     }}>
//                       {property.construction_status}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.length) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Length
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px'
//                     }}>
//                       {property.length} {property.length_units || property.property_size_units}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.width) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Width
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px'
//                     }}>
//                       {property.width} {property.width_units || property.property_size_units}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.total_floors) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Total Floors
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px'
//                     }}>
//                       {property.total_floors}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.select_floor) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Floor Number
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px'
//                     }}>
//                       {property.select_floor}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.furnish_type) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Furnishing
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                       textTransform: 'capitalize'
//                     }}>
//                       {property.furnish_type.replace(/-/g, ' ')}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.monthly_rent) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Monthly Rent
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px'
//                     }}>
//                       {formatCurrency(property.monthly_rent, property.currency)}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.security_deposit) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Security Deposit
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px'
//                     }}>
//                       {property.security_deposit}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.available_from) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Available From
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px'
//                     }}>
//                       {formatDate(property.available_from)}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.ownership) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Ownership
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                       textTransform: 'capitalize'
//                     }}>
//                       {property.ownership}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.hub) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                                         <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Hub
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px'
//                     }}>
//                       {property.hub}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.commercial_catgory) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Category
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px',
//                       textTransform: 'capitalize'
//                     }}>
//                       {property.commercial_catgory}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.landmark) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Landmark
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px'
//                     }}>
//                       {property.landmark}
//                     </Typography>
//                   </Grid>
//                 )}

//                 {hasValue(property?.zone_type) && (
//                   <Grid item xs={6} sm={4} md={3}>
//                     <Typography variant="body2" color="text.secondary" sx={{
//                       fontFamily: 'Outfit',
//                       fontSize: '12px',
//                       mb: 0.5
//                     }}>
//                       Zone Type
//                     </Typography>
//                     <Typography variant="body2" sx={{
//                       fontWeight: '500',
//                       fontFamily: 'Outfit',
//                       fontSize: '13px'
//                     }}>
//                       {property.zone_type}
//                     </Typography>
//                   </Grid>
//                 )}

//                 <Grid item xs={6} sm={4} md={3}>
//                   <Typography variant="body2" color="text.secondary" sx={{
//                     fontFamily: 'Outfit',
//                     fontSize: '12px',
//                     mb: 0.5
//                   }}>
//                     Category
//                   </Typography>
//                   <Typography variant="body2" sx={{
//                     fontWeight: '500',
//                     fontFamily: 'Outfit',
//                     fontSize: '13px',
//                     textTransform: 'capitalize'
//                   }}>
//                     {property?.category || 'Sale'}
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Box>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* Contact Dialog */}
//       <Dialog
//         open={contactDialogOpen}
//         onClose={() => setContactDialogOpen(false)}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle sx={{
//           fontFamily: 'Outfit',
//           fontWeight: 600,
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           borderBottom: '1px solid #e0e0e0',
//           pb: 2
//         }}>
//           Contact Information
//           <IconButton onClick={() => setContactDialogOpen(false)}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ pt: 3 }}>
//           <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
//             <Box
//               component="div"
//               sx={{
//                 width: 60,
//                 height: 60,
//                 borderRadius: '50%',
//                 bgcolor: '#f0f0f0',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 overflow: 'hidden',
//                 flexShrink: 0
//               }}
//             >
//               <img
//                 src={userProfile.profile_image || "https://propertydealstalk.com/api/portraits/men/32.jpg"}
//                 alt="Profile"
//                 style={{
//                   width: '100%',
//                   height: '100%',
//                   objectFit: 'cover'
//                 }}
//               />
//             </Box>
//             <Box sx={{ flex: 1 }}>
//               <Typography variant="subtitle1" sx={{
//                 fontWeight: '600',
//                 fontFamily: 'Outfit',
//                 mb: 2
//               }}>
//                 {userProfile.full_name || propertyData.seller.full_name}
//               </Typography>
//               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <PhoneIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1.5 }} />
//                   <Typography variant="body2" sx={{ fontFamily: 'Outfit', color: '#1976d2' }}>
//                     {userProfile.contact_number || propertyData.seller.contact_number}
//                   </Typography>
//                 </Box>
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <EmailIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1.5 }} />
//                   <Typography variant="body2" sx={{
//                     fontFamily: 'Outfit',
//                     wordBreak: 'break-word'
//                   }}>
//                     {userProfile.email_id || propertyData.seller.email_id}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e0e0e0' }}>
//           <Button
//             onClick={() => setContactDialogOpen(false)}
//             variant="contained"
//             sx={{
//               borderRadius: 2,
//               textTransform: 'none',
//               px: 3,
//               bgcolor: '#4285F4',
//               fontFamily: 'Outfit'
//             }}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Media Dialog with Navigation */}
//       <Dialog
//         open={mediaDialogOpen}
//         onClose={handleMediaClose}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogContent sx={{ position: 'relative', p: 0, backgroundColor: 'black' }}>
//           <IconButton
//             aria-label="close"
//             onClick={handleMediaClose}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//               color: 'white',
//               zIndex: 10,
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               '&:hover': {
//                 backgroundColor: 'rgba(0, 0, 0, 0.7)',
//               }
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//           <IconButton
//             aria-label="previous media"
//             onClick={() => handlePrevMedia(allMedia)}
//             disabled={currentMediaIndex === 0}
//             sx={{
//               position: 'absolute',
//               left: 8,
//               top: '50%',
//               transform: 'translateY(-50%)',
//               color: 'white',
//               zIndex: 10,
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               '&:hover': {
//                 backgroundColor: 'rgba(0, 0, 0, 0.7)',
//               },
//               opacity: currentMediaIndex === 0 ? 0.5 : 1,
//               visibility: currentMediaIndex === 0 ? 'hidden' : 'visible',
//             }}
//           >
//             <ChevronLeftIcon fontSize="large" />
//           </IconButton>
//           <IconButton
//             aria-label="next media"
//             onClick={() => handleNextMedia(allMedia)}
//             disabled={currentMediaIndex === allMedia.length - 1}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: '50%',
//               transform: 'translateY(-50%)',
//               color: 'white',
//               zIndex: 10,
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//               '&:hover': {
//                 backgroundColor: 'rgba(0, 0, 0, 0.7)',
//               },
//               opacity: currentMediaIndex === allMedia.length - 1 ? 0.5 : 1,
//               visibility: currentMediaIndex === allMedia.length - 1 ? 'hidden' : 'visible',
//             }}
//           >
//             <ChevronRightIcon fontSize="large" />
//           </IconButton>
//           <Box sx={{
//             position: 'absolute',
//             bottom: 16,
//             left: '50%',
//             transform: 'translateX(-50%)',
//             color: 'white',
//             zIndex: 10,
//             backgroundColor: 'rgba(0, 0, 0, 0.5)',
//             padding: '4px 12px',
//             borderRadius: 16,
//             fontSize: '14px',
//           }}>
//             {currentMediaIndex + 1} / {allMedia.length}
//           </Box>
//           <img
//             src={selectedMedia}
//             alt="Property"
//             style={{
//               width: '100%',
//               height: 'auto',
//               maxHeight: '80vh',
//               objectFit: 'contain'
//             }}
//           />
//         </DialogContent>
//       </Dialog>

//       {/* Photos Management Dialog */}
//       <Dialog
//         open={photosDialogOpen}
//         onClose={() => setPhotosDialogOpen(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle sx={{
//           fontFamily: 'Outfit',
//           fontWeight: 600,
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           borderBottom: '1px solid #e0e0e0',
//           pb: 2
//         }}>
//           Manage Property Photos
//           <IconButton onClick={() => setPhotosDialogOpen(false)}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent sx={{ pt: 3 }}>
//           <Box>
//             <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
//               <Button
//                 variant="contained"
//                 component="label"
//                 startIcon={<AddPhotoAlternateIcon />}
//                 sx={{
//                   bgcolor: '#4285F4',
//                   borderRadius: 2,
//                   textTransform: 'none',
//                   px: 3,
//                   py: 1,
//                   fontSize: '0.875rem'
//                 }}
//                 disabled={uploadedPhotos.length >= 10}
//               >
//                 Add Photos
//                 <input
//                   type="file"
//                   hidden
//                   accept="image/*"
//                   multiple
//                   onChange={(e) => handleFileUpload(e)}
//                 />
//               </Button>
//             </Box>
//             {uploadedPhotos.length >= 10 && (
//               <Typography
//                 variant="caption"
//                 color="error"
//                 align="center"
//                 sx={{ display: 'block', mb: 2 }}
//               >
//                 Maximum limit of 10 images reached
//               </Typography>
//             )}
//             <Grid container spacing={2}>
//               {uploadedPhotos.map((photo) => (
//                 <Grid item xs={12} sm={6} md={4} key={photo.id}>
//                   <Box sx={{
//                     position: 'relative',
//                     borderRadius: 2,
//                     overflow: 'hidden',
//                     height: 180
//                   }}>
//                     <img
//                       src={photo.preview}
//                       alt={photo.name}
//                       style={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'cover'
//                       }}
//                     />
//                     <IconButton
//                       sx={{
//                         position: 'absolute',
//                         top: 8,
//                         right: 8,
//                         bgcolor: 'rgba(0,0,0,0.5)',
//                         color: 'white',
//                         '&:hover': {
//                           bgcolor: 'rgba(0,0,0,0.7)'
//                         }
//                       }}
//                       onClick={() => handleDeleteMedia(photo.id)}
//                     >
//                       <DeleteIcon />
//                     </IconButton>
//                     {photo.isNew && (
//                       <Box
//                         sx={{
//                           position: 'absolute',
//                           top: 8,
//                           left: 8,
//                           backgroundColor: '#4285F4',
//                           color: 'white',
//                           fontSize: '10px',
//                           px: 1,
//                           py: 0.5,
//                           borderRadius: 1
//                         }}
//                       >
//                         New
//                       </Box>
//                     )}
//                   </Box>
//                 </Grid>
//               ))}
//             </Grid>
//             {uploadedPhotos.length === 0 && (
//               <Box sx={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 bgcolor: '#f5f5f5',
//                 borderRadius: 2,
//                 p: 4,
//                 mt: 2
//               }}>
//                 <Typography variant="body1" color="text.secondary" align="center">
//                   No photos uploaded yet. Click "Add Photos" to upload property images.
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary" align="center" sx={{ mt: 1 }}>
//                   Maximum 10 images allowed. Backend handles file size validation.
//                 </Typography>
//               </Box>
//             )}
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e0e0e0' }}>
//           <Button
//             onClick={() => setPhotosDialogOpen(false)}
//             variant="outlined"
//             sx={{
//               borderRadius: 2,
//               textTransform: 'none',
//               px: 3
//             }}
//             disabled={isUploading}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleSaveMedia}
//             variant="contained"
//             color="primary"
//             disabled={isUploading || (uploadedPhotos.filter(p => p.isNew).length === 0 && imagesToDelete.length === 0)}
//             sx={{
//               borderRadius: 2,
//               textTransform: 'none',
//               px: 3,
//               bgcolor: '#4285F4',
//               '&:hover': {
//                 bgcolor: '#3367d6',
//               }
//             }}
//           >
//             {isUploading ? (
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <CircularProgress size={20} sx={{ color: 'white' }} />
//                 <span>Saving...</span>
//               </Box>
//             ) : (
//               'Save Photos'
//             )}
//           </Button>
//         </DialogActions>
//         {isUploading && <Loader />}
//       </Dialog>

//       {/* ✅ Edit Listing Dialog with 2 Tabs (Property Details & Price/Rent) */}
//       <Dialog
//         open={editListingDialogOpen}
//         onClose={() => setEditListingDialogOpen(false)}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{
//           sx: {
//             maxHeight: '90vh',
//             height: '90vh'
//           }
//         }}
//       >
//         <DialogTitle sx={{
//           fontFamily: 'Outfit',
//           fontWeight: 600,
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           borderBottom: '1px solid #e0e0e0',
//           pb: 2
//         }}>
//           Edit Property Listing
//           <IconButton onClick={() => setEditListingDialogOpen(false)}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         {/* Tabs Navigation */}
//         <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3 }}>
//           <Tabs 
//             value={currentTab} 
//             onChange={(e, newValue) => setCurrentTab(newValue)}
//             sx={{
//               '& .MuiTab-root': {
//                 fontFamily: 'Outfit',
//                 textTransform: 'none',
//                 fontSize: '14px'
//               }
//             }}
//           >
//             <Tab label="Property Details" />
//             <Tab label={typeInfo.isRent ? "Rent Details" : "Price Details"} />
//           </Tabs>
//         </Box>

//         <DialogContent sx={{ pt: 3, overflow: 'auto' }}>
//           {/* TAB 1: Property Details */}
//           {currentTab === 0 && (
//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
//               {/* Building/Project Name & Area Name */}
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={6}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Building/Project Name <span style={{ color: '#d32f2f' }}>*</span>
//                   </Typography>
//                   <TextField
//                     fullWidth
//                     name="property_name"
//                     value={editedProperty?.property_name || ''}
//                     onChange={handleInputChange}
//                     placeholder="Enter building name"
//                     size="small"
//                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Area Name <span style={{ color: '#d32f2f' }}>*</span>
//                   </Typography>
//                   <TextField
//                     fullWidth
//                     name="area_name"
//                     value={editedProperty?.area_name || ''}
//                     onChange={handleInputChange}
//                     placeholder="Enter area name"
//                     size="small"
//                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                   />
//                 </Grid>
//               </Grid>

//               {/* Complete Address & Description */}
//               <Grid container spacing={2}>
//                <Grid item xs={12} md={6}>
//   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//     Complete Address <span style={{ color: '#d32f2f' }}>*</span>
//   </Typography>
//   <TextField
//     fullWidth
//     name="full_address"
//     value={editedProperty?.full_address || ''}
//     onChange={(e) => {
//       const value = e.target.value;
      
//       // ✅ Extract numbers and check if they exceed 5 digits
//       const numbers = value.replace(/\D/g, '');
      
//       // ✅ Only update if numbers are 5 or less
//       if (numbers.length <= 5) {
//         handleInputChange(e);
//       }
//     }}
//     placeholder="Enter complete address (max 5 digits allowed)"
//     multiline
//     rows={3}
//     size="small"
//     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//   />
//                  </Grid>


//                 <Grid item xs={12} md={6}>
//   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//     Description <span style={{ color: '#999', fontSize: '11px' }}>(Optional - max 5 digits)</span>
//   </Typography>
//   <TextField
//     fullWidth
//     name="description"
//     value={editedProperty?.description || ''}
//     onChange={(e) => {
//       const value = e.target.value;
      
//       // ✅ Extract numbers and check if they exceed 5 digits
//       const numbers = value.replace(/\D/g, '');
      
//       // ✅ Only update if numbers are 5 or less
//       if (numbers.length <= 5) {
//         handleInputChange(e);
//       }
//     }}
//     placeholder="Enter property description (max 5 digits allowed)"
//     multiline
//     rows={3}
//     size="small"
//     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//   />
// </Grid>
//               </Grid>

//               {/* Social Media Link */}
//               <Box>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                 </Typography>
//                 <TextField
//                   fullWidth
//                   name="youtube_link"
//                   value={editedProperty?.youtube_link || ''}
//                   onChange={handleInputChange}
//                   placeholder="YouTube, Facebook, WhatsApp, Instagram"
//                   size="small"
//                   InputProps={{
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Box>

//               {/* ✅ APARTMENT FIELDS */}
//               {typeInfo.isApartment && (
//                 <>
//                   {/* BHK, Bathrooms, Furnish Type */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         BHK <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="bhk"
//                           value={editedProperty?.bhk || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                           <MenuItem value="1">1 BHK</MenuItem>
//                           <MenuItem value="2">2 BHK</MenuItem>
//                           <MenuItem value="3">3 BHK</MenuItem>
//                           <MenuItem value="4">4 BHK</MenuItem>
//                           <MenuItem value="5">5 BHK</MenuItem>
//                           <MenuItem value="6">6 BHK</MenuItem>
//                           <MenuItem value="7">6+ BHK</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Bathrooms <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="bathrooms"
//                           value={editedProperty?.bathrooms || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value=""><em>Select Bathrooms</em></MenuItem>
//                           <MenuItem value="1">1</MenuItem>
//                           <MenuItem value="2">2</MenuItem>
//                           <MenuItem value="3">3</MenuItem>
//                           <MenuItem value="4">4</MenuItem>
//                           <MenuItem value="5">5</MenuItem>
//                           <MenuItem value="6">6+</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="furnish_type"
//                           value={editedProperty?.furnish_type || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                           <MenuItem value="fully-furnished">Fully Furnished</MenuItem>
//                           <MenuItem value="semi-furnished">Semi Furnished</MenuItem>
//                           <MenuItem value="un-furnished">Un Furnished</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </Grid>

//                   {/* Contact Information (Disabled) */}
//                   {!typeInfo.isCommercial && (
//                     <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//                       <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 2 }}>
//                         Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <Grid container spacing={2}>
//                         <Grid item xs={12} md={4}>
//                           <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                             Owner Name
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             name="owner_name"
//                             value={userProfile.full_name || 'N/A'}
//                             disabled
//                             size="small"
//                             sx={{ 
//                               '& .MuiOutlinedInput-root': { 
//                                 borderRadius: 1.5, 
//                                 fontFamily: 'Outfit', 
//                                 fontSize: '13px',
//                                 backgroundColor: '#f5f5f5'
//                               } 
//                             }}
//                           />
//                         </Grid>

//                         <Grid item xs={12} md={4}>
//                           <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                             Contact Number
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             name="contact_number"
//                             value={userProfile.contact_number || 'N/A'}
//                             disabled
//                             size="small"
//                             sx={{ 
//                               '& .MuiOutlinedInput-root': { 
//                                 borderRadius: 1.5, 
//                                 fontFamily: 'Outfit', 
//                                 fontSize: '13px',
//                                 backgroundColor: '#f5f5f5'
//                               } 
//                             }}
//                           />
//                         </Grid>

//                         <Grid item xs={12} md={4}>
//                           <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                             Email Address
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             name="email_address"
//                             value={userProfile.email_id || 'N/A'}
//                             disabled
//                             size="small"
//                             sx={{ 
//                               '& .MuiOutlinedInput-root': { 
//                                 borderRadius: 1.5, 
//                                 fontFamily: 'Outfit', 
//                                 fontSize: '13px',
//                                 backgroundColor: '#f5f5f5'
//                               } 
//                             }}
//                           />
//                         </Grid>
//                       </Grid>
//                     </Box>
//                   )}

//                   {/* Carpet Area, Built-up Area, UDS */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Carpet Area <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="carpet_area"
//                         type="number"
//                         value={editedProperty?.carpet_area || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter carpet area"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="built_up_area"
//                         type="number"
//                         value={editedProperty?.built_up_area || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter built-up area"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         UDS <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="uds"
//                         type="number"
//                         value={editedProperty?.uds || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter UDS"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Yards</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>
//                   </Grid>
//                 </>
//               )}

//               {/* ✅ INDEPENDENT HOUSE FIELDS - NO TOTAL FLOORS */}
// {typeInfo.isIndependentHouse && (
//   <>
//     {/* BHK, Bathrooms, Furnish Type */}
//     <Grid container spacing={2}>
//       <Grid item xs={12} md={4}>
//         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//           BHK <span style={{ color: '#d32f2f' }}>*</span>
//         </Typography>
//         <FormControl fullWidth size="small">
//           <Select
//             name="bhk"
//             value={editedProperty?.bhk || ''}
//             onChange={handleInputChange}
//             displayEmpty
//             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//           >
//             <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//             <MenuItem value="1">1 BHK</MenuItem>
//             <MenuItem value="2">2 BHK</MenuItem>
//             <MenuItem value="3">3 BHK</MenuItem>
//             <MenuItem value="4">4 BHK</MenuItem>
//             <MenuItem value="5">5 BHK</MenuItem>
//             <MenuItem value="6">6 BHK</MenuItem>
//             <MenuItem value="7">6+ BHK</MenuItem>
//           </Select>
//         </FormControl>
//       </Grid>

//       <Grid item xs={12} md={4}>
//         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//           Bathrooms <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//         </Typography>
//         <FormControl fullWidth size="small">
//           <Select
//             name="bathrooms"
//             value={editedProperty?.bathrooms || ''}
//             onChange={handleInputChange}
//             displayEmpty
//             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//           >
//             <MenuItem value=""><em>Select Bathrooms</em></MenuItem>
//             <MenuItem value="1">1</MenuItem>
//             <MenuItem value="2">2</MenuItem>
//             <MenuItem value="3">3</MenuItem>
//             <MenuItem value="4">4</MenuItem>
//             <MenuItem value="5">5</MenuItem>
//             <MenuItem value="6">6+</MenuItem>
//           </Select>
//         </FormControl>
//       </Grid>

//       <Grid item xs={12} md={4}>
//         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//           Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//         </Typography>
//         <FormControl fullWidth size="small">
//           <Select
//             name="furnish_type"
//             value={editedProperty?.furnish_type || ''}
//             onChange={handleInputChange}
//             displayEmpty
//             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//           >
//             <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//             <MenuItem value="fully-furnished">Fully Furnished</MenuItem>
//             <MenuItem value="semi-furnished">Semi Furnished</MenuItem>
//             <MenuItem value="un-furnished">Un Furnished</MenuItem>
//           </Select>
//         </FormControl>
//       </Grid>
//     </Grid>

//     {/* Contact Information (Disabled) */}
//     {!typeInfo.isCommercial && (
//       <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//         <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 2 }}>
//           Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//         </Typography>
//         <Grid container spacing={2}>
//           <Grid item xs={12} md={4}>
//             <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//               Owner Name
//             </Typography>
//             <TextField
//               fullWidth
//               name="owner_name"
//               value={userProfile.full_name || 'N/A'}
//               disabled
//               size="small"
//               sx={{ 
//                 '& .MuiOutlinedInput-root': { 
//                   borderRadius: 1.5, 
//                   fontFamily: 'Outfit', 
//                   fontSize: '13px',
//                   backgroundColor: '#f5f5f5'
//                 } 
//               }}
//             />
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//               Contact Number
//             </Typography>
//             <TextField
//               fullWidth
//               name="contact_number"
//               value={userProfile.contact_number || 'N/A'}
//               disabled
//               size="small"
//               sx={{ 
//                 '& .MuiOutlinedInput-root': { 
//                   borderRadius: 1.5, 
//                   fontFamily: 'Outfit', 
//                   fontSize: '13px',
//                   backgroundColor: '#f5f5f5'
//                 } 
//               }}
//             />
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//               Email Address
//             </Typography>
//             <TextField
//               fullWidth
//               name="email_address"
//               value={userProfile.email_id || 'N/A'}
//               disabled
//               size="small"
//               sx={{ 
//                 '& .MuiOutlinedInput-root': { 
//                   borderRadius: 1.5, 
//                   fontFamily: 'Outfit', 
//                   fontSize: '13px',
//                   backgroundColor: '#f5f5f5'
//                 } 
//               }}
//             />
//           </Grid>
//         </Grid>
//       </Box>
//     )}

//     {/* ✅ Built-up Area, Property Size, UDS - NO TOTAL FLOORS */}
//     <Grid container spacing={2}>
//       <Grid item xs={12} md={4}>
//         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//           Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
//         </Typography>
//         <TextField
//           fullWidth
//           name="built_up_area"
//           type="number"
//           value={editedProperty?.built_up_area || ''}
//           onChange={handleInputChange}
//           placeholder="Enter built-up area"
//           size="small"
//           InputProps={{
//             endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//           }}
//           sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//         />
//       </Grid>

//       <Grid item xs={12} md={4}>
//         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//           Property Size <span style={{ color: '#d32f2f' }}>*</span>
//         </Typography>
//         <TextField
//           fullWidth
//           name="property_size"
//           type="number"
//           value={editedProperty?.property_size || ''}
//           onChange={handleInputChange}
//           placeholder="Enter property size"
//           size="small"
//           InputProps={{
//             endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//           }}
//           sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//         />
//       </Grid>

//       <Grid item xs={12} md={4}>
//         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//           UDS <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//         </Typography>
//         <TextField
//           fullWidth
//           name="uds"
//           type="number"
//           value={editedProperty?.uds || ''}
//           onChange={handleInputChange}
//           placeholder="Enter UDS"
//           size="small"
//           InputProps={{
//             endAdornment: <InputAdornment position="end">Sq.Yards</InputAdornment>,
//           }}
//           sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//         />
//       </Grid>
//     </Grid>
//   </>
// )}

//               {/* ✅ PENT HOUSE FIELDS - Only Built-up Area */}
//               {typeInfo.isPentHouse && (
//                 <>
//                   {/* BHK, Bathrooms, Furnish Type */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         BHK <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="bhk"
//                           value={editedProperty?.bhk || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                           <MenuItem value="1">1 BHK</MenuItem>
//                           <MenuItem value="2">2 BHK</MenuItem>
//                           <MenuItem value="3">3 BHK</MenuItem>
//                           <MenuItem value="4">4 BHK</MenuItem>
//                           <MenuItem value="5">5 BHK</MenuItem>
//                           <MenuItem value="6">6 BHK</MenuItem>
//                           <MenuItem value="7">6+ BHK</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Bathrooms <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="bathrooms"
//                           value={editedProperty?.bathrooms || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value=""><em>Select Bathrooms</em></MenuItem>
//                           <MenuItem value="1">1</MenuItem>
//                           <MenuItem value="2">2</MenuItem>
//                           <MenuItem value="3">3</MenuItem>
//                           <MenuItem value="4">4</MenuItem>
//                           <MenuItem value="5">5</MenuItem>
//                           <MenuItem value="6">6+</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="furnish_type"
//                           value={editedProperty?.furnish_type || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                           <MenuItem value="fully-furnished">Fully Furnished</MenuItem>
//                           <MenuItem value="semi-furnished">Semi Furnished</MenuItem>
//                           <MenuItem value="un-furnished">Un Furnished</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </Grid>

//                   {/* Contact Information (Disabled) */}
//                   {!typeInfo.isCommercial && (
//                     <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//                       <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 2 }}>
//                         Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <Grid container spacing={2}>
//                         <Grid item xs={12} md={4}>
//                           <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                             Owner Name
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             name="owner_name"
//                             value={userProfile.full_name || 'N/A'}
//                             disabled
//                             size="small"
//                             sx={{ 
//                               '& .MuiOutlinedInput-root': { 
//                                 borderRadius: 1.5, 
//                                 fontFamily: 'Outfit', 
//                                 fontSize: '13px',
//                                 backgroundColor: '#f5f5f5'
//                               } 
//                             }}
//                           />
//                         </Grid>

//                         <Grid item xs={12} md={4}>
//                           <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                             Contact Number
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             name="contact_number"
//                             value={userProfile.contact_number || 'N/A'}
//                             disabled
//                             size="small"
//                             sx={{ 
//                               '& .MuiOutlinedInput-root': { 
//                                 borderRadius: 1.5, 
//                                 fontFamily: 'Outfit', 
//                                 fontSize: '13px',
//                                 backgroundColor: '#f5f5f5'
//                               } 
//                             }}
//                           />
//                         </Grid>

//                         <Grid item xs={12} md={4}>
//                           <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                             Email Address
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             name="email_address"
//                             value={userProfile.email_id || 'N/A'}
//                             disabled
//                             size="small"
//                             sx={{ 
//                               '& .MuiOutlinedInput-root': { 
//                                 borderRadius: 1.5, 
//                                 fontFamily: 'Outfit', 
//                                 fontSize: '13px',
//                                 backgroundColor: '#f5f5f5'
//                               } 
//                             }}
//                           />
//                         </Grid>
//                       </Grid>
//                     </Box>
//                   )}

//                   {/* Built-up Area ONLY */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="built_up_area"
//                         type="number"
//                         value={editedProperty?.built_up_area || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter built-up area"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>
//                   </Grid>
//                 </>
//               )}

//               {/* ✅ STUDIO FIELDS */}
//               {typeInfo.isStudio && (
//                 <>
//                   {/* BHK, Bathrooms, Furnish Type */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         BHK <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="bhk"
//                           value={editedProperty?.bhk || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                           <MenuItem value="1">1 BHK</MenuItem>
//                           <MenuItem value="2">2 BHK</MenuItem>
//                           <MenuItem value="3">3 BHK</MenuItem>
//                           <MenuItem value="4">4 BHK</MenuItem>
//                           <MenuItem value="5">5 BHK</MenuItem>
//                           <MenuItem value="6">6 BHK</MenuItem>
//                           <MenuItem value="7">6+ BHK</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Bathrooms <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="bathrooms"
//                           value={editedProperty?.bathrooms || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value=""><em>Select Bathrooms</em></MenuItem>
//                           <MenuItem value="1">1</MenuItem>
//                           <MenuItem value="2">2</MenuItem>
//                           <MenuItem value="3">3</MenuItem>
//                           <MenuItem value="4">4</MenuItem>
//                           <MenuItem value="5">5</MenuItem>
//                           <MenuItem value="6">6+</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="furnish_type"
//                           value={editedProperty?.furnish_type || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                           <MenuItem value="fully-furnished">Fully Furnished</MenuItem>
//                           <MenuItem value="semi-furnished">Semi Furnished</MenuItem>
//                           <MenuItem value="un-furnished">Un Furnished</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </Grid>

//                   {/* Contact Information (Disabled) */}
//                   {!typeInfo.isCommercial && (
//                     <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//                       <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 2 }}>
//                         Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <Grid container spacing={2}>
//                         <Grid item xs={12} md={4}>
//                           <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                             Owner Name
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             name="owner_name"
//                             value={userProfile.full_name || 'N/A'}
//                             disabled
//                             size="small"
//                             sx={{ 
//                               '& .MuiOutlinedInput-root': { 
//                                 borderRadius: 1.5, 
//                                 fontFamily: 'Outfit', 
//                                 fontSize: '13px',
//                                 backgroundColor: '#f5f5f5'
//                               } 
//                             }}
//                           />
//                         </Grid>

//                         <Grid item xs={12} md={4}>
//                           <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                             Contact Number
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             name="contact_number"
//                             value={userProfile.contact_number || 'N/A'}
//                             disabled
//                             size="small"
//                             sx={{ 
//                               '& .MuiOutlinedInput-root': { 
//                                 borderRadius: 1.5, 
//                                 fontFamily: 'Outfit', 
//                                 fontSize: '13px',
//                                 backgroundColor: '#f5f5f5'
//                               } 
//                             }}
//                           />
//                         </Grid>

//                         <Grid item xs={12} md={4}>
//                           <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                             Email Address
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             name="email_address"
//                             value={userProfile.email_id || 'N/A'}
//                             disabled
//                             size="small"
//                             sx={{ 
//                               '& .MuiOutlinedInput-root': { 
//                                 borderRadius: 1.5, 
//                                 fontFamily: 'Outfit', 
//                                 fontSize: '13px',
//                                 backgroundColor: '#f5f5f5'
//                               } 
//                             }}
//                           />
//                         </Grid>
//                       </Grid>
//                     </Box>
//                   )}

//                   {/* Property Size */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="property_size"
//                         type="number"
//                         value={editedProperty?.property_size || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter property size"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>
//                   </Grid>
//                 </>
//               )}

//              {/* ✅ VILLA FIELDS */}
// {typeInfo.isVilla && (
//   <>
//     {/* BHK, Bathrooms, Furnish Type */}
//     <Grid container spacing={2}>
//       <Grid item xs={12} md={4}>
//         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//           BHK <span style={{ color: '#d32f2f' }}>*</span>
//         </Typography>
//         <FormControl fullWidth size="small">
//           <Select
//             name="bhk"
//             value={editedProperty?.bhk || ''}
//             onChange={handleInputChange}
//             displayEmpty
//             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//           >
//             <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//             <MenuItem value="1">1 BHK</MenuItem>
//             <MenuItem value="2">2 BHK</MenuItem>
//             <MenuItem value="3">3 BHK</MenuItem>
//             <MenuItem value="4">4 BHK</MenuItem>
//             <MenuItem value="5">5 BHK</MenuItem>
//             <MenuItem value="6">6 BHK</MenuItem>
//             <MenuItem value="7">6+ BHK</MenuItem>
//           </Select>
//         </FormControl>
//       </Grid>

//       <Grid item xs={12} md={4}>
//         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//           Bathrooms <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//         </Typography>
//         <FormControl fullWidth size="small">
//           <Select
//             name="bathrooms"
//             value={editedProperty?.bathrooms || ''}
//             onChange={handleInputChange}
//             displayEmpty
//             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//           >
//             <MenuItem value=""><em>Select Bathrooms</em></MenuItem>
//             <MenuItem value="1">1</MenuItem>
//             <MenuItem value="2">2</MenuItem>
//             <MenuItem value="3">3</MenuItem>
//             <MenuItem value="4">4</MenuItem>
//             <MenuItem value="5">5</MenuItem>
//             <MenuItem value="6">6+</MenuItem>
//           </Select>
//         </FormControl>
//       </Grid>

//       <Grid item xs={12} md={4}>
//         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//           Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//         </Typography>
//         <FormControl fullWidth size="small">
//           <Select
//             name="furnish_type"
//             value={editedProperty?.furnish_type || ''}
//             onChange={handleInputChange}
//             displayEmpty
//             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//           >
//             <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//             <MenuItem value="fully-furnished">Fully Furnished</MenuItem>
//             <MenuItem value="semi-furnished">Semi Furnished</MenuItem>
//             <MenuItem value="un-furnished">Un Furnished</MenuItem>
//           </Select>
//         </FormControl>
//       </Grid>
//     </Grid>

//     {/* Contact Information (Disabled) */}
//     {!typeInfo.isCommercial && (
//       <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//         <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 2 }}>
//           Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//         </Typography>
//         <Grid container spacing={2}>
//           <Grid item xs={12} md={4}>
//             <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//               Owner Name
//             </Typography>
//             <TextField
//               fullWidth
//               name="owner_name"
//               value={userProfile.full_name || 'N/A'}
//               disabled
//               size="small"
//               sx={{ 
//                 '& .MuiOutlinedInput-root': { 
//                   borderRadius: 1.5, 
//                   fontFamily: 'Outfit', 
//                   fontSize: '13px',
//                   backgroundColor: '#f5f5f5'  // ✅ FIXED
//                 } 
//               }}
//             />
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//               Contact Number
//             </Typography>
//             <TextField
//               fullWidth
//               name="contact_number"
//               value={userProfile.contact_number || 'N/A'}
//               disabled
//               size="small"
//               sx={{ 
//                 '& .MuiOutlinedInput-root': { 
//                   borderRadius: 1.5, 
//                   fontFamily: 'Outfit', 
//                   fontSize: '13px',
//                   backgroundColor: '#f5f5f5'
//                 } 
//               }}
//             />
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//               Email Address
//             </Typography>
//             <TextField
//               fullWidth
//               name="email_address"
//               value={userProfile.email_id || 'N/A'}
//               disabled
//               size="small"
//               sx={{ 
//                 '& .MuiOutlinedInput-root': { 
//                   borderRadius: 1.5, 
//                   fontFamily: 'Outfit', 
//                   fontSize: '13px',
//                   backgroundColor: '#f5f5f5'
//                 } 
//               }}
//             />
//           </Grid>
//         </Grid>
//       </Box>
//     )}

//     {/* Built-up Area and Property Size - NO UDS */}
//     <Grid container spacing={2}>
//       <Grid item xs={12} md={6}>
//         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//           Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
//         </Typography>
//         <TextField
//           fullWidth
//           name="built_up_area"
//           type="number"
//           value={editedProperty?.built_up_area || ''}
//           onChange={handleInputChange}
//           placeholder="Enter built-up area"
//           size="small"
//           InputProps={{
//             endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//           }}
//           sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//         />
//       </Grid>

//       <Grid item xs={12} md={6}>
//         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//           Property Size <span style={{ color: '#d32f2f' }}>*</span>
//         </Typography>
//         <TextField
//           fullWidth
//           name="property_size"
//           type="number"
//           value={editedProperty?.property_size || ''}
//           onChange={handleInputChange}
//           placeholder="Enter property size"
//           size="small"
//           InputProps={{
//             endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//           }}
//           sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//         />
//       </Grid>
//     </Grid>
//   </>
// )}

//               {/* ✅ PLOT FIELDS (Residential only) */}
//               {typeInfo.isPlot && !typeInfo.isCommercial && (
//                 <>
//                   {/* Property Size, Zone Type, Ownership */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="property_size"
//                         type="number"
//                         value={editedProperty?.property_size || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter property size"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Yards</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="zone_type"
//                         value={editedProperty?.zone_type || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter zone type"
//                         size="small"
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Ownership <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="ownership"
//                           value={editedProperty?.ownership || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value=""><em>Select Ownership</em></MenuItem>
//                           <MenuItem value="Freehold">Freehold</MenuItem>
//                           <MenuItem value="Leasehold">Leasehold</MenuItem>
//                           <MenuItem value="Cooperative society">Cooperative society</MenuItem>
//                           <MenuItem value="Power of attorney">Power of attorney</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </Grid>

//                   {/* Length and Width */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Length <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="length"
//                         type="number"
//                         value={editedProperty?.length || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter length"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Width <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="width"
//                         type="number"
//                         value={editedProperty?.width || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter width"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>
//                   </Grid>

//                   {/* Landmark */}
//                   <Box>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                       Landmark <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       name="landmark"
//                       value={editedProperty?.landmark || ''}
//                       onChange={handleInputChange}
//                       placeholder="Enter nearby landmark"
//                       size="small"
//                       sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                     />
//                   </Box>
//                 </>
//               )}

//               {/* ✅ AGRICULTURE LAND FIELDS */}
//               {typeInfo.isAgricultureLand && (
//                 <>
//                   {/* Property Size, Zone Type, Ownership */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="property_size"
//                         type="number"
//                         value={editedProperty?.property_size || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter property size"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Yards</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="zone_type"
//                         value={editedProperty?.zone_type || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter zone type"
//                         size="small"
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Ownership <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="ownership"
//                           value={editedProperty?.ownership || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value=""><em>Select Ownership</em></MenuItem>
//                           <MenuItem value="Freehold">Freehold</MenuItem>
//                           <MenuItem value="Leasehold">Leasehold</MenuItem>
//                           <MenuItem value="Cooperative society">Cooperative society</MenuItem>
//                           <MenuItem value="Power of attorney">Power of attorney</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </Grid>

//                   {/* Landmark */}
//                   <Box>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                       Landmark <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       name="landmark"
//                       value={editedProperty?.landmark || ''}
//                       onChange={handleInputChange}
//                       placeholder="Enter nearby landmark"
//                       size="small"
//                       sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                     />
//                   </Box>
//                 </>
//               )}

//               {/* ✅ FARMHOUSE FIELDS */}
//               {typeInfo.isFarmhouse && (
//                 <>
//                   {/* BHK, Bathrooms, Furnish Type */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         BHK <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="bhk"
//                           value={editedProperty?.bhk || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                           <MenuItem value="1">1 BHK</MenuItem>
//                           <MenuItem value="2">2 BHK</MenuItem>
//                           <MenuItem value="3">3 BHK</MenuItem>
//                           <MenuItem value="4">4 BHK</MenuItem>
//                           <MenuItem value="5">5 BHK</MenuItem>
//                           <MenuItem value="6">6 BHK</MenuItem>
//                           <MenuItem value="7">6+ BHK</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Bathrooms <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="bathrooms"
//                           value={editedProperty?.bathrooms || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value=""><em>Select Bathrooms</em></MenuItem>
//                           <MenuItem value="1">1</MenuItem>
//                           <MenuItem value="2">2</MenuItem>
//                           <MenuItem value="3">3</MenuItem>
//                           <MenuItem value="4">4</MenuItem>
//                           <MenuItem value="5">5</MenuItem>
//                           <MenuItem value="6">6+</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="furnish_type"
//                           value={editedProperty?.furnish_type || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                           <MenuItem value="fully-furnished">Fully Furnished</MenuItem>
//                           <MenuItem value="semi-furnished">Semi Furnished</MenuItem>
//                           <MenuItem value="un-furnished">Un Furnished</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </Grid>

//                   {/* Built-up Area and Property Size */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="built_up_area"
//                         type="number"
//                         value={editedProperty?.built_up_area || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter built-up area"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="property_size"
//                         type="number"
//                         value={editedProperty?.property_size || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter property size"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Acres</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>
//                   </Grid>
//                 </>
//               )}

//               {/* ✅ COMMERCIAL OFFICE FIELDS */}
//               {typeInfo.isCommercial && typeInfo.isOffice && (
//                 <>
//                   {/* Property Size */}
//                   <Box>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                       Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       name="property_size"
//                       type="number"
//                       value={editedProperty?.property_size || ''}
//                       onChange={handleInputChange}
//                       placeholder="Enter property size"
//                       size="small"
//                       InputProps={{
//                         endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                       }}
//                       sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                     />
//                   </Box>

//                   {/* Built-up Area and Zone Type (Optional) */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="built_up_area"
//                         type="number"
//                         value={editedProperty?.built_up_area || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter built-up area"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="zone_type"
//                         value={editedProperty?.zone_type || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter zone type"
//                         size="small"
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>
//                   </Grid>

//                   {/* Available Floors Section */}
//                   <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//                     <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 2 }}>
//                       Available Floors <span style={{ color: '#d32f2f' }}>*</span>
//                     </Typography>
//                     <Grid container spacing={2}>
//                       <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                           Total Floors
//                         </Typography>
//                         <TextField
//                           fullWidth
//                           name="total_floors"
//                           type="number"
//                           value={editedProperty?.total_floors || ''}
//                           onChange={handleInputChange}
//                           placeholder="Total floors"
//                           size="small"
//                           sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                         />
//                       </Grid>

//                       <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                           Select Floor
//                         </Typography>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             name="select_floor"
//                             value={editedProperty?.select_floor || ''}
//                             onChange={handleInputChange}
//                             displayEmpty
//                             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                           >
//                             <MenuItem value="" disabled>Select Floor</MenuItem>
//                             {[...Array(20)].map((_, i) => (
//                               <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
//                                 {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
//                               </MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </Grid>

//                       <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                           Ownership
//                         </Typography>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             name="ownership"
//                             value={editedProperty?.ownership || ''}
//                             onChange={handleInputChange}
//                             displayEmpty
//                             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                           >
//                             <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
//                             <MenuItem value="Freehold">Freehold</MenuItem>
//                             <MenuItem value="Leasehold">Leasehold</MenuItem>
//                             <MenuItem value="Cooperative society">Cooperative society</MenuItem>
//                             <MenuItem value="Power of attorney">Power of attorney</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </Grid>

//                       <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                           Hub
//                         </Typography>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             name="hub"
//                             value={editedProperty?.hub || ''}
//                             onChange={handleInputChange}
//                             displayEmpty
//                             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                           >
//                             <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
//                             <MenuItem value="IT Park">IT Park</MenuItem>
//                             <MenuItem value="Business Park">Business Park</MenuItem>
//                             <MenuItem value="Others">Others</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </Grid>
//                     </Grid>
//                   </Box>
//                 </>
//               )}

//               {/* ✅ COMMERCIAL SHOWROOM & RETAIL SHOP FIELDS */}
//               {typeInfo.isCommercial && (typeInfo.isShowroom || typeInfo.isRetailShop) && (
//                 <>
//                   {/* Property Size */}
//                   <Box>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                       Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       name="property_size"
//                       type="number"
//                       value={editedProperty?.property_size || ''}
//                       onChange={handleInputChange}
//                       placeholder="Enter property size"
//                       size="small"
//                       InputProps={{
//                         endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                       }}
//                       sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                     />
//                   </Box>

//                   {/* Built-up Area and Carpet Area (Optional) */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="built_up_area"
//                         type="number"
//                         value={editedProperty?.built_up_area || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter built-up area"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Carpet Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="carpet_area"
//                         type="number"
//                         value={editedProperty?.carpet_area || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter carpet area"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>
//                   </Grid>

//                   {/* Available Floors Section */}
//                   <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//                     <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 2 }}>
//                       Available Floors <span style={{ color: '#d32f2f' }}>*</span>
//                     </Typography>
//                     <Grid container spacing={2}>
//                       <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                           Total Floors
//                         </Typography>
//                         <TextField
//                           fullWidth
//                           name="total_floors"
//                           type="number"
//                           value={editedProperty?.total_floors || ''}
//                           onChange={handleInputChange}
//                           placeholder="Total floors"
//                           size="small"
//                           sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                         />
//                       </Grid>

//                       <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                           Select Floor
//                         </Typography>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             name="select_floor"
//                             value={editedProperty?.select_floor || ''}
//                             onChange={handleInputChange}
//                             displayEmpty
//                             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                           >
//                             <MenuItem value="" disabled>Select Floor</MenuItem>
//                             {[...Array(20)].map((_, i) => (
//                               <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
//                                 {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
//                               </MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </Grid>

//                       <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                           Ownership
//                         </Typography>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             name="ownership"
//                             value={editedProperty?.ownership || ''}
//                             onChange={handleInputChange}
//                             displayEmpty
//                             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                           >
//                             <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
//                             <MenuItem value="Freehold">Freehold</MenuItem>
//                             <MenuItem value="Leasehold">Leasehold</MenuItem>
//                             <MenuItem value="Cooperative society">Cooperative society</MenuItem>
//                             <MenuItem value="Power of attorney">Power of attorney</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </Grid>

//                       <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                           Hub
//                         </Typography>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             name="hub"
//                             value={editedProperty?.hub || ''}
//                             onChange={handleInputChange}
//                             displayEmpty
//                             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                           >
//                             <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
//                             <MenuItem value="IT Park">IT Park</MenuItem>
//                             <MenuItem value="Business Park">Business Park</MenuItem>
//                             <MenuItem value="Others">Others</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </Grid>
//                     </Grid>
//                   </Box>
//                 </>
//               )}

//               {/* ✅ COMMERCIAL WAREHOUSE FIELDS */}
//               {typeInfo.isCommercial && typeInfo.isWarehouse && (
//                 <>
//                   {/* Property Size */}
//                   <Box>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                       Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                     </Typography>
//                     <TextField
//                       fullWidth
//                       name="property_size"
//                       type="number"
//                       value={editedProperty?.property_size || ''}
//                       onChange={handleInputChange}
//                       placeholder="Enter property size"
//                       size="small"
//                       InputProps={{
//                         endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                       }}
//                       sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                     />
//                   </Box>

//                   {/* Zone Type, Built-up Area, Carpet Area (All Optional) */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="zone_type"
//                         value={editedProperty?.zone_type || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter zone type"
//                         size="small"
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="built_up_area"
//                         type="number"
//                         value={editedProperty?.built_up_area || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter built-up area"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Carpet Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="carpet_area"
//                         type="number"
//                         value={editedProperty?.carpet_area || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter carpet area"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>
//                   </Grid>

//                   {/* Available Floors Section */}
//                   <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
//                     <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 2 }}>
//                       Available Floors <span style={{ color: '#d32f2f' }}>*</span>
//                     </Typography>
//                     <Grid container spacing={2}>
//                       <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                           Total Floors
//                         </Typography>
//                         <TextField
//                           fullWidth
//                           name="total_floors"
//                           type="number"
//                           value={editedProperty?.total_floors || ''}
//                           onChange={handleInputChange}
//                           placeholder="Total floors"
//                           size="small"
//                           sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                         />
//                       </Grid>

//                       <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                           Select Floor
//                         </Typography>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             name="select_floor"
//                             value={editedProperty?.select_floor || ''}
//                             onChange={handleInputChange}
//                             displayEmpty
//                             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                           >
//                             <MenuItem value="" disabled>Select Floor</MenuItem>
//                             {[...Array(20)].map((_, i) => (
//                               <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
//                                 {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
//                               </MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </Grid>

//                       <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                           Ownership
//                         </Typography>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             name="ownership"
//                             value={editedProperty?.ownership || ''}
//                             onChange={handleInputChange}
//                             displayEmpty
//                             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                           >
//                             <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
//                             <MenuItem value="Freehold">Freehold</MenuItem>
//                             <MenuItem value="Leasehold">Leasehold</MenuItem>
//                             <MenuItem value="Cooperative society">Cooperative society</MenuItem>
//                             <MenuItem value="Power of attorney">Power of attorney</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </Grid>

//                       <Grid item xs={12} md={3}>
//                         <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                           Hub
//                         </Typography>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             name="hub"
//                             value={editedProperty?.hub || ''}
//                             onChange={handleInputChange}
//                             displayEmpty
//                             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                           >
//                             <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
//                             <MenuItem value="IT Park">IT Park</MenuItem>
//                             <MenuItem value="Business Park">Business Park</MenuItem>
//                             <MenuItem value="Others">Others</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </Grid>
//                     </Grid>
//                   </Box>
//                 </>
//               )}

//               {/* ✅ COMMERCIAL PLOT FIELDS */}
//               {typeInfo.isCommercial && typeInfo.isPlot && (
//                 <>
//                   {/* Property Size, Zone Type, Ownership */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="property_size"
//                         type="number"
//                         value={editedProperty?.property_size || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter property size"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Yards</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="zone_type"
//                         value={editedProperty?.zone_type || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter zone type"
//                         size="small"
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={4}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Ownership <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="ownership"
//                           value={editedProperty?.ownership || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value=""><em>Select Ownership</em></MenuItem>
//                           <MenuItem value="Freehold">Freehold</MenuItem>
//                           <MenuItem value="Leasehold">Leasehold</MenuItem>
//                           <MenuItem value="Cooperative society">Cooperative society</MenuItem>
//                           <MenuItem value="Power of attorney">Power of attorney</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </Grid>

//                   {/* Length and Width */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Length <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="length"
//                         type="number"
//                         value={editedProperty?.length || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter length"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Width <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="width"
//                         type="number"
//                         value={editedProperty?.width || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter width"
//                         size="small"
//                         InputProps={{
//                           endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>
//                   </Grid>
//                 </>
//               )}
//             </Box>
//           )}

//           {/* TAB 2: Price/Rent Details */}
//           {currentTab === 1 && (
//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
//               {typeInfo.isRent ? (
//                 <>
//                   {/* Rent Details */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Monthly Rent <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="monthly_rent"
//                         type="number"
//                         value={editedProperty?.monthly_rent || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter amount"
//                         size="small"
//                         InputProps={{
//                           startAdornment: <InputAdornment position="start">₹</InputAdornment>
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Available from <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="available_from"
//                         type="date"
//                         value={editedProperty?.available_from ? editedProperty.available_from.split('T')[0]: ''}
//                         onChange={handleInputChange}
//                         size="small"
//                         InputLabelProps={{ shrink: true }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Security Deposit <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="security_deposit"
//                           value={editedProperty?.security_deposit || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value="" disabled>Select Security Deposit</MenuItem>
//                           <MenuItem value="none">None</MenuItem>
//                           <MenuItem value="1month">1 Month</MenuItem>
//                           <MenuItem value="2month">2 Months</MenuItem>
//                           <MenuItem value="custom">Custom</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </Grid>
//                 </>
//               ) : (
//                 <>
//                   {/* Sale/Price Details */}
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Property Cost <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <TextField
//                         fullWidth
//                         name="asking_price"
//                         type="number"
//                         value={editedProperty?.asking_price || ''}
//                         onChange={handleInputChange}
//                         placeholder="Enter amount"
//                         size="small"
//                         InputProps={{
//                           startAdornment: <InputAdornment position="start">₹</InputAdornment>
//                         }}
//                         sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Construction Status <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="construction_status"
//                           value={editedProperty?.construction_status || ''}
//                           onChange={handleInputChange}
//                           displayEmpty
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value="" disabled>Select Status</MenuItem>
//                           <MenuItem value="ready to move">Ready to Move</MenuItem>
//                           <MenuItem value="under construction">Under Construction</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>

//                     <Grid item xs={12} md={6}>
//                       <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                         Price Negotiable? <span style={{ color: '#d32f2f' }}>*</span>
//                       </Typography>
//                       <FormControl fullWidth size="small">
//                         <Select
//                           name="negotiable"
//                           value={editedProperty?.negotiable === true || editedProperty?.negotiable === 'true' ? 'true' : 'false'}
//                           onChange={handleInputChange}
//                           sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                         >
//                           <MenuItem value="true">Yes</MenuItem>
//                           <MenuItem value="false">No</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </Grid>
//                   </Grid>
//                 </>
//               )}
//             </Box>
//           )}
//         </DialogContent>

//         <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e0e0e0', justifyContent: 'space-between' }}>
//           <Button
//             onClick={() => setEditListingDialogOpen(false)}
//             variant="outlined"
//             sx={{
//               borderRadius: 2,
//               textTransform: 'none',
//               px: 3,
//               fontFamily: 'Outfit'
//             }}
//             disabled={isSaving}
//           >
//             Cancel
//           </Button>
          
//           <Box sx={{ display: 'flex', gap: 2 }}>
//             {currentTab > 0 && (
//               <Button
//                 onClick={() => setCurrentTab(prev => prev - 1)}
//                 variant="outlined"
//                 sx={{
//                   borderRadius: 2,
//                   textTransform: 'none',
//                   px: 3,
//                   fontFamily: 'Outfit'
//                 }}
//                 disabled={isSaving}
//               >
//                 Back
//               </Button>
//             )}
            
//             {currentTab < 1 ? (
//               <Button
//                 onClick={() => setCurrentTab(prev => prev + 1)}
//                 variant="contained"
//                 sx={{
//                   borderRadius: 2,
//                   textTransform: 'none',
//                   px: 3,
//                   fontFamily: 'Outfit',
//                   bgcolor: '#4285F4',
//                   '&:hover': {
//                     bgcolor: '#3367d6',
//                   }
//                 }}
//               >
//                 Next
//               </Button>
//             ) : (
//               <Button
//                 onClick={() => handleSaveChanges('listing')}
//                 variant="contained"
//                 color="primary"
//                 disabled={isSaving}
//                 sx={{
//                   borderRadius: 2,
//                   textTransform: 'none',
//                   px: 3,
//                   fontFamily: 'Outfit',
//                   bgcolor: '#4285F4',
//                   '&:hover': {
//                     bgcolor: '#3367d6',
//                   }
//                 }}
//               >
//                 {isSaving ? (
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <CircularProgress size={20} sx={{ color: 'white' }} />
//                     <span>Saving...</span>
//                   </Box>
//                 ) : (
//                   'Save Changes'
//                 )}
//               </Button>
//             )}
//           </Box>
//         </DialogActions>
//       </Dialog>

//       {/* Manage Amenities Dialog */}
//       <Dialog
//         open={amenitiesDialogOpen}
//         onClose={() => setAmenitiesDialogOpen(false)}
//         maxWidth="lg"
//         fullWidth
//         fullScreen={window.innerWidth < 600}
//         sx={{
//           '& .MuiDialog-paper': {
//             borderRadius: window.innerWidth < 600 ? 0 : '16px',
//             maxHeight: window.innerWidth < 600 ? '100vh' : '90vh',
//             margin: window.innerWidth < 600 ? 0 : 2,
//           }
//         }}
//       >
//         <DialogTitle sx={{
//           fontFamily: 'Outfit',
//           fontWeight: 600,
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           borderBottom: '1px solid #e0e0e0',
//           pb: 2,
//           px: window.innerWidth < 600 ? 2 : 3
//         }}>
//           Manage Property Amenities
//           <IconButton onClick={() => setAmenitiesDialogOpen(false)}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
        
//         <DialogContent sx={{ 
//           pt: 3, 
//           pb: window.innerWidth < 600 ? 10 : 3,
//           px: window.innerWidth < 600 ? 2 : 3 
//         }}>
//           <Box>
//             {/* Society Amenities Section */}
//             <Box sx={{ mb: 4 }}>
//               <Typography
//                 variant="h6"
//                 sx={{
//                   fontFamily: 'Outfit',
//                   fontWeight: 500,
//                   color: '#333',
//                   mb: 2,
//                   fontSize: window.innerWidth < 600 ? '16px' : '18px'
//                 }}
//               >
//                 Society Amenities
//               </Typography>
//               <FormControl fullWidth size="small">
//                 <Select
//                   multiple
//                   value={editedProperty?.society_aminities ? editedProperty.society_aminities.split(', ').filter(item => item) : []}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     setEditedProperty(prev => ({
//                       ...prev,
//                       society_aminities: typeof value === 'string' ? value : value.join(', ')
//                     }));
//                   }}
//                   renderValue={(selected) => (
//                     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                       {selected.map((value) => {
//                         const amenity = societyAmenitiesData.find(a => a.name === value);
//                         return (
//                           <Box 
//                             key={value}
//                             sx={{
//                               display: 'flex',
//                               alignItems: 'center',
//                               gap: 0.5,
//                               px: 1,
//                               py: 0.5,
//                               border: '1px solid #e0e0e0',
//                               borderRadius: 1,
//                               backgroundColor: 'transparent'
//                             }}
//                           >
//                             {amenity && (
//                               <Box
//                                 component="img"
//                                 src={amenity.icon}
//                                 alt={value}
//                                 sx={{
//                                   width: 16,
//                                   height: 16,
//                                   objectFit: 'contain'
//                                 }}
//                               />
//                             )}
//                             <Typography sx={{ 
//                               fontFamily: 'Outfit', 
//                               fontSize: '12px',
//                               color: '#333'
//                             }}>
//                               {value}
//                             </Typography>
//                           </Box>
//                         );
//                       })}
//                     </Box>
//                   )}
//                   sx={{ 
//                     borderRadius: 1.5, 
//                     fontFamily: 'Outfit', 
//                     fontSize: '13px',
//                     '& .MuiOutlinedInput-notchedOutline': {
//                       borderColor: '#e0e0e0'
//                     }
//                   }}
//                   MenuProps={{
//                     PaperProps: {
//                       style: {
//                         maxHeight: 400,
//                       },
//                     },
//                   }}
//                 >
//                   {societyAmenitiesData.map((amenity) => (
//                     <MenuItem 
//                       key={amenity.name} 
//                       value={amenity.name}
//                       sx={{
//                         fontFamily: 'Outfit',
//                         fontSize: '14px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 1.5,
//                         py: 1.5,
//                         backgroundColor: editedProperty?.society_aminities?.split(', ').includes(amenity.name) ? '#f5f5f5' : 'transparent',
//                         '&:hover': {
//                           backgroundColor: '#f0f0f0'
//                         }
//                       }}
//                     >
//                       <Box
//                         component="img"
//                         src={amenity.icon}
//                         alt={amenity.name}
//                         sx={{
//                           width: 24,
//                           height: 24,
//                           objectFit: 'contain'
//                         }}
//                       />
//                       <Typography sx={{ fontFamily: 'Outfit', fontSize: '14px', flex: 1 }}>
//                         {amenity.name}
//                       </Typography>
//                       {editedProperty?.society_aminities?.split(', ').includes(amenity.name) && (
//                         <CheckIcon sx={{ color: '#4285F4', fontSize: 20 }} />
//                       )}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Box>

//             {/* Furnishing Facilities Section */}
//             <Box sx={{ mb: 4 }}>
//               <Typography
//                 variant="h6"
//                 sx={{
//                   fontFamily: 'Outfit',
//                   fontWeight: 500,
//                   color: '#333',
//                   mb: 2,
//                   fontSize: window.innerWidth < 600 ? '16px' : '18px'
//                 }}
//               >
//                 Furnishing Facilities
//               </Typography>
//               <FormControl fullWidth size="small">
//                 <Select
//                   multiple
//                   value={editedProperty?.furnish_facilities ? editedProperty.furnish_facilities.split(', ').filter(item => item) : []}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     setEditedProperty(prev => ({
//                       ...prev,
//                       furnish_facilities: typeof value === 'string' ? value : value.join(', ')
//                     }));
//                   }}
//                   renderValue={(selected) => (
//                     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                       {selected.map((value) => {
//                         const facility = furnishingFacilitiesData.find(f => f.name === value);
//                         return (
//                           <Box 
//                             key={value}
//                             sx={{
//                               display: 'flex',
//                               alignItems: 'center',
//                               gap: 0.5,
//                               px: 1,
//                               py: 0.5,
//                               border: '1px solid #e0e0e0',
//                               borderRadius: 1,
//                               backgroundColor: 'transparent'
//                             }}
//                           >
//                             {facility && (
//                               <Box
//                                 component="img"
//                                 src={facility.icon}
//                                 alt={value}
//                                 sx={{
//                                   width: 16,
//                                   height: 16,
//                                   objectFit: 'contain'
//                                 }}
//                               />
//                             )}
//                             <Typography sx={{ 
//                               fontFamily: 'Outfit', 
//                               fontSize: '12px',
//                               color: '#333'
//                             }}>
//                               {value}
//                             </Typography>
//                           </Box>
//                         );
//                       })}
//                     </Box>
//                   )}
//                   sx={{ 
//                     borderRadius: 1.5, 
//                     fontFamily: 'Outfit', 
//                     fontSize: '13px',
//                     '& .MuiOutlinedInput-notchedOutline': {
//                       borderColor: '#e0e0e0'
//                     }
//                   }}
//                   MenuProps={{
//                     PaperProps: {
//                       style: {
//                         maxHeight: 400,
//                       },
//                     },
//                   }}
//                 >
//                   {furnishingFacilitiesData.map((facility) => (
//                     <MenuItem 
//                       key={facility.name} 
//                       value={facility.name}
//                       sx={{
//                         fontFamily: 'Outfit',
//                         fontSize: '14px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 1.5,
//                         py: 1.5,
//                         backgroundColor: editedProperty?.furnish_facilities?.split(', ').includes(facility.name) ? '#f5f5f5' : 'transparent',
//                         '&:hover': {
//                           backgroundColor: '#f0f0f0'
//                         }
//                       }}
//                     >
//                       <Box
//                         component="img"
//                         src={facility.icon}
//                         alt={facility.name}
//                         sx={{
//                           width: 24,
//                           height: 24,
//                           objectFit: 'contain'
//                         }}
//                       />
//                       <Typography sx={{ fontFamily: 'Outfit', fontSize: '14px', flex: 1 }}>
//                         {facility.name}
//                       </Typography>
//                       {editedProperty?.furnish_facilities?.split(', ').includes(facility.name) && (
//                         <CheckIcon sx={{ color: '#4285F4', fontSize: 20 }} />
//                       )}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Box>

//             {/* Other Facilities Section */}
//             <Box sx={{ mb: 4 }}>
//               <Typography
//                 variant="h6"
//                 sx={{
//                   fontFamily: 'Outfit',
//                   fontWeight: 500,
//                   color: '#333',
//                   mb: 2,
//                   fontSize: window.innerWidth < 600 ? '16px' : '18px'
//                 }}
//               >
//                 Other Facilities
//               </Typography>
//               <FormControl fullWidth size="small">
//                 <Select
//                   multiple
//                   value={editedProperty?.other_facilities ? editedProperty.other_facilities.split(', ').filter(item => item) : []}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     setEditedProperty(prev => ({
//                       ...prev,
//                       other_facilities: typeof value === 'string' ? value : value.join(', ')
//                     }));
//                   }}
//                   renderValue={(selected) => (
//                     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                       {selected.map((value) => (
//                         <Box 
//                           key={value}
//                           sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             px: 1,
//                             py: 0.5,
//                             border: '1px solid #e0e0e0',
//                             borderRadius: 1,
//                             backgroundColor: 'transparent'
//                           }}
//                         >
//                           <Typography sx={{ 
//                             fontFamily: 'Outfit', 
//                             fontSize: '12px',
//                             color: '#333'
//                           }}>
//                             {value}
//                           </Typography>
//                         </Box>
//                       ))}
//                     </Box>
//                   )}
//                   sx={{ 
//                     borderRadius: 1.5, 
//                     fontFamily: 'Outfit', 
//                     fontSize: '13px',
//                     '& .MuiOutlinedInput-notchedOutline': {
//                       borderColor: '#e0e0e0'
//                     }
//                   }}
//                   MenuProps={{
//                     PaperProps: {
//                       style: {
//                         maxHeight: 400,
//                       },
//                     },
//                   }}
//                 >
//                   {otherFacilitiesData.map((facility) => (
//                     <MenuItem 
//                       key={facility} 
//                       value={facility}
//                       sx={{
//                         fontFamily: 'Outfit',
//                         fontSize: '14px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'space-between',
//                         py: 1.5,
//                         backgroundColor: editedProperty?.other_facilities?.split(', ').includes(facility) ? '#f5f5f5' : 'transparent',
//                         '&:hover': {
//                           backgroundColor: '#f0f0f0'
//                         }
//                       }}
//                     >
//                       <Typography sx={{ fontFamily: 'Outfit', fontSize: '14px' }}>
//                         {facility}
//                       </Typography>
//                       {editedProperty?.other_facilities?.split(', ').includes(facility) && (
//                         <CheckIcon sx={{ color: '#4285F4', fontSize: 20 }} />
//                       )}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Box>
//           </Box>
//         </DialogContent>
        
//         <DialogActions sx={{
//           p: window.innerWidth < 600 ? 2 : 3,
//           justifyContent: 'space-between',
//           borderTop: '1px solid #e0e0e0',
//           position: window.innerWidth < 600 ? 'fixed' : 'relative',
//           bottom: window.innerWidth < 600 ? 0 : 'auto',
//           left: window.innerWidth < 600 ? 0 : 'auto',
//           right: window.innerWidth < 600 ? 0 : 'auto',
//           backgroundColor: 'white',
//           gap: 2
//         }}>
//           <Button
//             onClick={() => {
//               setAmenitiesDialogOpen(false);
//             }}
//             variant="outlined"
//             sx={{
//               flex: window.innerWidth < 600 ? 1 : 'none',
//               height: window.innerWidth < 600 ? 48 : 'auto',
//               borderRadius: 2,
//               textTransform: 'none',
//               px: 3,
//               fontFamily: 'Outfit',
//               borderColor: '#e0e0e0',
//               color: '#666',
//               '&:hover': {
//                 borderColor: '#4285F4',
//                 backgroundColor: 'transparent'
//               }
//             }}
//             disabled={isSaving}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={() => handleSaveChanges('amenities')}
//             variant="contained"
//             disabled={isSaving}
//             sx={{
//               flex: window.innerWidth < 600 ? 1 : 'none',
//               height: window.innerWidth < 600 ? 48 : 'auto',
//               borderRadius: 2,
//               textTransform: 'none',
//               px: 3,
//               fontFamily: 'Outfit',
//               bgcolor: '#4285F4',
//               '&:hover': {
//                 bgcolor: '#3367d6'
//               }
//             }}
//           >
//             {isSaving ? (
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <CircularProgress size={20} sx={{ color: 'white' }} />
//                 <span>Saving...</span>
//               </Box>
//             ) : (
//               'Save Amenities'
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Alert Dialog */}
//       <Dialog
//         open={alertDialog.open}
//         onClose={handleAlertClose}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle sx={{
//           fontFamily: 'Outfit',
//           fontWeight: 600,
//           color: alertDialog.severity === 'success' ? '#2e7d32' : '#d32f2f',
//           borderBottom: '1px solid #e0e0e0',
//           pb: 2
//         }}>
//           {alertDialog.severity === 'success' ? 'Success' : 'Error'}
//         </DialogTitle>
//         <DialogContent sx={{ pt: 3, pb: 1 }}>
//           <DialogContentText sx={{ fontFamily: 'Outfit' }}>
//             {alertDialog.message}
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions sx={{ px: 3, py: 2 }}>
//           <Button
//             onClick={handleAlertClose}
//             variant="contained"
//             color={alertDialog.severity === 'success' ? 'primary' : 'error'}
//             sx={{
//               borderRadius: 2,
//               textTransform: 'none',
//               px: 3,
//               fontFamily: 'Outfit'
//             }}
//           >
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default EditProperties;

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Grid,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  CircularProgress,
  Tabs,
  Tab,
  Snackbar,
  Alert,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HotelIcon from '@mui/icons-material/Hotel';
import BathtubIcon from '@mui/icons-material/Bathtub';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CheckIcon from '@mui/icons-material/Check';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import WarningIcon from '@mui/icons-material/Warning';
import Loader from '../Loader/Loader';
import { selectUser } from '../Commonlibs/userSlice';
import EditResidential from './EditResidential';
import EditCommercial from './EditCommercial';

// Import amenity icons
import liftIcon from '../assets/applift.png';
import cctvIcon from '../assets/appctv.png';
import gymIcon from '../assets/appfit.png';
import gardenIcon from '../assets/appgarden.png';
import kidsAreaIcon from '../assets/appkids.png';
import sportsIcon from '../assets/appsport.png';
import swimmingPoolIcon from '../assets/appswim.png';
import intercomIcon from '../assets/appinter.png';
import gatedCommunityIcon from '../assets/appgate.png';
import clubHouseIcon from '../assets/appclub.png';
import communityHallIcon from '../assets/appcom.png';
import regularWaterSupplyIcon from '../assets/appregul.png';
import powerBackupIcon from '../assets/apppower.png';
import petAllowedIcon from '../assets/apppet.png';
import diningTableIcon from '../assets/appdinner.png';
import washingMachineIcon from '../assets/appwash.png';
import sofaIcon from '../assets/appsofa.png';
import microwaveIcon from '../assets/appmicro.png';
import fridgeIcon from '../assets/appfridge.png';
import waterPurifierIcon from '../assets/appwater.png';
import gasPipelineIcon from '../assets/appgas.png';
import acIcon from '../assets/appac.png';
import bedIcon from '../assets/appbed.png';
import tvIcon from '../assets/apptv.png';
import cupboardIcon from '../assets/appcup.png';
import geyserIcon from '../assets/appgeyser.png';

// Amenities data
const societyAmenitiesData = [
  { name: "Lift", icon: liftIcon },
  { name: "CCTV", icon: cctvIcon },
  { name: "Gym", icon: gymIcon },
  { name: "Garden", icon: gardenIcon },
  { name: "Kids Area", icon: kidsAreaIcon },
  { name: "Sports", icon: sportsIcon },
  { name: "Swimming Pool", icon: swimmingPoolIcon },
  { name: "Intercom", icon: intercomIcon },
  { name: "Gated Community", icon: gatedCommunityIcon },
  { name: "Club House", icon: clubHouseIcon },
  { name: "Community Hall", icon: communityHallIcon },
  { name: "Regular Water Supply", icon: regularWaterSupplyIcon },
  { name: "Power backup", icon: powerBackupIcon },
  { name: "Pet Allowed", icon: petAllowedIcon },
];

const furnishingFacilitiesData = [
  { name: "Dining Table", icon: diningTableIcon },
  { name: "Washing Machine", icon: washingMachineIcon },
  { name: "Sofa", icon: sofaIcon },
  { name: "Microwave", icon: microwaveIcon },
  { name: "Fridge", icon: fridgeIcon },
  { name: "Water Purifier", icon: waterPurifierIcon },
  { name: "Gas Pipeline", icon: gasPipelineIcon },
  { name: "AC", icon: acIcon },
  { name: "Bed", icon: bedIcon },
  { name: "TV", icon: tvIcon },
  { name: "Cupboard", icon: cupboardIcon },
  { name: "Geyser", icon: geyserIcon },
];

const otherFacilitiesData = [
  "Hospital", "School", "Park", "Shopping Mall",
  "Metro Station", "Bus Stop", "Restaurant", "Pharmacy"
];

const EditProperties = () => {
  const { propertyId } = useParams();
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  const [loading, setLoading] = useState(true);
  const [property, setProperty] = useState(null);
  const [error, setError] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [mediaDialogOpen, setMediaDialogOpen] = useState(false);
  const [mediaType, setMediaType] = useState('image');
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const [editListingDialogOpen, setEditListingDialogOpen] = useState(false);
  const [amenitiesDialogOpen, setAmenitiesDialogOpen] = useState(false);
  const [editedProperty, setEditedProperty] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [imagesToDelete, setImagesToDelete] = useState([]);
  const [alertDialog, setAlertDialog] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [photosDialogOpen, setPhotosDialogOpen] = useState(false);
  const [uploadedPhotos, setUploadedPhotos] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [userProfile, setUserProfile] = useState({
    full_name: '',
    email_id: '',
    contact_number: '',
    profile_image: null
  });
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState(0);
  
  const [lastPhotoWarningOpen, setLastPhotoWarningOpen] = useState(false);
  const [photoToDelete, setPhotoToDelete] = useState(null);

  const hasValue = (value) => {
    return value !== null && value !== undefined && value !== '';
  };

  const shouldShowAmenities = () => {
    if (!property) return false;
    const propertyType = property.property_type?.toLowerCase();
    const assetType = property.asset_type?.toLowerCase();
    const isFarmhouse = assetType === 'farm house' || assetType === 'farmhouse';
    const isVilla = assetType === 'villa';
    const isPlot = assetType === 'plot';
    const isAgricultureLand = assetType === 'agriculture land';

    return (propertyType === 'residential' && !isPlot && !isAgricultureLand) || 
           (propertyType === 'commercial' && (isFarmhouse || isVilla));
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatCurrency = (amount, currency = '₹') => {
    if (!amount) return `${currency}0`;
    return `${currency}${Number(amount).toLocaleString()}`;
  };

  const processMedia = (mediaData) => {
    if (!mediaData || !Array.isArray(mediaData)) return [];

    return mediaData
      .map(item => {
        try {
          if (typeof item === 'object' && item?.image) {
            const imageData = item.image.startsWith('data:')
              ? item.image
              : `data:image/png;base64,${item.image}`;

            return {
              type: 'image',
              data: imageData,
              id: item.id || `temp-${Math.random()}`,
              image_name: item.image_name || 'Property Image'
            };
          }
          return null;
        } catch (error) {
          console.error('Error processing media item:', error);
          return null;
        }
      })
      .filter(item => item !== null);
  };

  const getMainImage = (mediaArray) => {
    if (!mediaArray || mediaArray.length === 0) return null;
    const firstImage = mediaArray.find(item => item.type === 'image');
    return firstImage ? firstImage.data : null;
  };

  const getAdditionalMedia = (mediaArray) => {
    if (!mediaArray || mediaArray.length <= 1) return [];
    return mediaArray.slice(1).slice(0, 3);
  };

  const handleMediaOpen = (media, type, index) => {
    setSelectedMedia(media);
    setMediaType(type);
    setCurrentMediaIndex(index !== undefined ? index : 0);
    setMediaDialogOpen(true);
  };

  const handleMediaClose = () => {
    setMediaDialogOpen(false);
    setSelectedMedia(null);
  };

  const handleNextMedia = (allMedia) => {
    if (currentMediaIndex < allMedia.length - 1) {
      const nextIndex = currentMediaIndex + 1;
      const nextMedia = allMedia[nextIndex];
      setSelectedMedia(nextMedia.data);
      setMediaType(nextMedia.type);
      setCurrentMediaIndex(nextIndex);
    }
  };

  const handlePrevMedia = (allMedia) => {
    if (currentMediaIndex > 0) {
      const prevIndex = currentMediaIndex - 1;
      const prevMedia = allMedia[prevIndex];
      setSelectedMedia(prevMedia.data);
      setMediaType(prevMedia.type);
      setCurrentMediaIndex(prevIndex);
    }
  };

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);

    if (uploadedPhotos.length + files.length > 10) {
      setAlertDialog({
        open: true,
        message: `You can only upload a maximum of 10 images. Currently you have ${uploadedPhotos.length} images.`,
        severity: 'error'
      });
      return;
    }

    const validImages = files.filter(file => file.type.startsWith('image/'));

    if (validImages.length !== files.length) {
      setAlertDialog({
        open: true,
        message: 'Some files were skipped (invalid image type)',
        severity: 'warning'
      });
    }

    validImages.forEach(file => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const newMedia = {
          id: `temp-${Date.now()}-${Math.random()}`,
          name: file.name,
          size: file.size,
          type: 'image',
          preview: e.target.result,
          file: file,
          isNew: true
        };
        setUploadedPhotos(prev => [...prev, newMedia]);
      };
      reader.onerror = (error) => {
        console.error('Error reading file:', error);
        setAlertDialog({
          open: true,
          message: `Failed to read file: ${file.name}`,
          severity: 'error'
        });
      };
      reader.readAsDataURL(file);
    });

    event.target.value = '';
  };

  const handleDeleteMedia = (id) => {
    const remainingPhotos = uploadedPhotos.filter(item => item.id !== id);
    
    if (remainingPhotos.length === 0) {
      setPhotoToDelete(id);
      setLastPhotoWarningOpen(true);
      return;
    }

    const photoToDelete = uploadedPhotos.find(item => item.id === id);

    if (photoToDelete && !photoToDelete.isNew) {
      setImagesToDelete(prev => [...prev, id]);
    }

    setUploadedPhotos(prev => prev.filter(item => item.id !== id));
  };

  const handleForceDeleteLastPhoto = () => {
    setLastPhotoWarningOpen(false);
    setPhotoToDelete(null);
  };

  const handleSaveMedia = async () => {
    setIsUploading(true);

    try {
      if (imagesToDelete.length > 0) {
        for (const imageId of imagesToDelete) {
          try {
            const deletePayload = {
              property_id: property?.id,
              seller_id: user?.id || property?.seller_id,
              image_id: imageId
            };

            const deleteResponse = await fetch('https://propertydealstalk.com/api/property/removePropertyImage', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(deletePayload)
            });

            const deleteData = await deleteResponse.json();

            if (deleteData.status !== "SUCCESS") {
              console.warn(`Failed to delete image ${imageId}:`, deleteData.message);
            }
          } catch (deleteError) {
            console.error(`Error deleting image ${imageId}:`, deleteError);
          }
        }

        setImagesToDelete([]);
      }

      const newPhotos = uploadedPhotos.filter(photo => photo.isNew && photo.file);

      if (newPhotos.length > 0) {
        const formData = new FormData();
        formData.append('property_id', String(property?.id));
        formData.append('seller_id', String(user?.id || property?.seller_id));

        newPhotos.forEach((photo) => {
          formData.append('property_images', photo.file, photo.file.name);
        });

        const response = await fetch('https://propertydealstalk.com/api/property/updateProperty', {
          method: 'POST',
          body: formData,
        });

        const responseText = await response.text();

        let data;
        try {
          data = JSON.parse(responseText);
        } catch (parseError) {
          throw new Error(`Server returned invalid response: ${responseText.substring(0, 200)}`);
        }

        if (!response.ok || data.status !== "SUCCESS") {
          throw new Error(data.message || 'Failed to upload images');
        }
      }

      const refreshResponse = await fetch(`https://propertydealstalk.com/api/property/getProperties?property_id=${property?.id}&timestamp=${Date.now()}`);
      const refreshData = await refreshResponse.json();

      if (refreshData.status === "SUCCESS") {
        const propertyData = Array.isArray(refreshData.result) ? refreshData.result[0] : refreshData.result;
        setProperty(propertyData);

        const allMedia = processMedia(propertyData?.images || []);
        const photos = allMedia.filter(item => item.type === 'image').map(item => ({
          id: item.id,
          name: item.image_name || 'Property Image',
          preview: item.data,
          type: 'image',
          isNew: false
        }));
        setUploadedPhotos(photos);
      }

      setPhotosDialogOpen(false);

      const deletedCount = imagesToDelete.length;
      const uploadedCount = newPhotos.length;
      let message = '';

      if (deletedCount > 0 && uploadedCount > 0) {
        message = `Deleted ${deletedCount} image(s) and uploaded ${uploadedCount} new image(s)!`;
      } else if (deletedCount > 0) {
        message = `Successfully deleted ${deletedCount} image(s)!`;
      } else if (uploadedCount > 0) {
        message = `Successfully uploaded ${uploadedCount} new image(s)!`;
      } else {
        message = 'No changes made';
      }

      setAlertDialog({
        open: true,
        message: message,
        severity: 'success'
      });
    } catch (error) {
      console.error('=== Save Media Error ===');
      console.error('Error:', error);
      setAlertDialog({
        open: true,
        message: `Failed to save changes: ${error.message}`,
        severity: 'error'
      });
    } finally {
      setIsUploading(false);
    }
  };

  useEffect(() => {
    const fetchPropertyDetails = async () => {
      try {
        setLoading(true);
        const response = await fetch(`https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}`);
        const data = await response.json();

        if (data.status === "SUCCESS") {
          const propertyData = Array.isArray(data.result) ? data.result[0] : data.result;

          if (propertyData) {
            setProperty(propertyData);
            setEditedProperty(propertyData);
          } else {
            setError('Property not found');
          }
        } else {
          setError('Failed to fetch property details');
        }
      } catch (error) {
        setError('Error fetching property details');
        console.error('Error fetching property details:', error);
      } finally {
        setLoading(false);
      }
    };

    if (propertyId) {
      fetchPropertyDetails();
    }
  }, [propertyId]);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        if (!user?.id) return;

        const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${user.id}`);
        const data = await response.json();

        if (data.status === "SUCCESS") {
          setUserProfile({
            full_name: data.result.full_name || '',
            email_id: data.result.email_id || '',
            contact_number: data.result.contact_number || '',
            profile_image: data.result.profile_image || null
          });
        }
      } catch (err) {
        console.error('Error fetching user profile:', err);
      }
    };

    fetchUserProfile();
  }, [user?.id]);

  const handleEditProperty = (section) => {
    if (section === 'listing') {
      setCurrentTab(0);
      setEditListingDialogOpen(true);
    } else if (section === 'amenities') {
      if (!shouldShowAmenities()) {
        setAlertDialog({
          open: true,
          message: 'Amenities are not applicable for this property type',
          severity: 'error'
        });
        return;
      }
      setAmenitiesDialogOpen(true);
    } else if (section === 'photos') {
      setPhotosDialogOpen(true);

      const allMedia = processMedia(property?.images || []);
      const photos = allMedia.filter(item => item.type === 'image').map(item => ({
        id: item.id,
        name: item.image_name || 'Property Image',
        preview: item.data,
        type: 'image',
        isNew: false
      }));
      setUploadedPhotos(photos);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedProperty(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSaveChanges = async (dialogType) => {
    try {
      setIsSaving(true);

      const payload = {
        property_id: editedProperty?.id,
        seller_id: user?.id || editedProperty?.seller_id || 1,
        property_type: editedProperty?.property_type,
        asset_type: editedProperty?.asset_type,
      };

      if (dialogType === 'listing') {
        const numericFields = [
          'asking_price', 'property_size', 'bhk', 'bathrooms',
          'total_floors', 'select_floor',
          'monthly_rent', 'carpet_area', 'built_up_area', 'uds',
          'length', 'width'
        ];

        const fieldsToCheck = [
          'property_name', 'location', 'area_name', 'asking_price',
          'currency', 'property_size', 'property_size_units', 'bhk',
          'bathrooms', 'description', 'total_floors', 'select_floor',
          'furnish_type', 'negotiable',
          'construction_status', 'full_address', 'youtube_link',
          'carpet_area', 'carpet_area_units', 'built_up_area',
          'built_up_area_units', 'uds', 'uds_units', 'monthly_rent', 'security_deposit',
          'available_from', 'length', 'width', 'ownership',
          'commercial_catgory', 'commercial_asset_type', 'hub', 'landmark',
          'locality', 'length_units', 'width_units', 'zone_type'
        ];

        fieldsToCheck.forEach(field => {
          if (editedProperty?.[field] !== undefined &&
            editedProperty?.[field] !== null &&
            editedProperty?.[field] !== '') {
            if (numericFields.includes(field)) {
              const numValue = Number(editedProperty[field]);
              if (!isNaN(numValue)) {
                payload[field] = numValue;
              }
            } else if (field === 'negotiable') {
              payload[field] = editedProperty[field] === 'true' || editedProperty[field] === true;
            } else {
              payload[field] = editedProperty[field];
            }
          }
        });
      } else if (dialogType === 'amenities') {
        if (!shouldShowAmenities()) {
          setAlertDialog({
            open: true,
            message: 'Amenities are not applicable for this property type',
            severity: 'error'
          });
          setIsSaving(false);
          return;
        }

        payload.society_aminities = editedProperty?.society_aminities || '';
        payload.furnish_facilities = editedProperty?.furnish_facilities || '';
        payload.other_facilities = editedProperty?.other_facilities || '';
      }

      console.log('📤 Update Payload:', payload);

      const response = await fetch('https://propertydealstalk.com/api/property/updateProperty', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data.status === "SUCCESS") {
        const refreshResponse = await fetch(`https://propertydealstalk.com/api/property/getProperties?property_id=${propertyId}&timestamp=${new Date().getTime()}`);
        const refreshData = await refreshResponse.json();

        if (refreshData.status === "SUCCESS") {
          const propertyData = Array.isArray(refreshData.result) ? refreshData.result[0] : refreshData.result;
          setProperty(propertyData);
          setEditedProperty(propertyData);
        }

        if (dialogType === 'listing') {
          setEditListingDialogOpen(false);
        } else if (dialogType === 'amenities') {
          setAmenitiesDialogOpen(false);
        }

        setAlertDialog({
          open: true,
          message: 'Property updated successfully!',
          severity: 'success'
        });
      } else {
        throw new Error(data.message || 'Failed to update property');
      }
    } catch (error) {
      console.error('Error updating property:', error);
      setAlertDialog({
        open: true,
        message: error.message || 'Failed to update property. Please try again.',
        severity: 'error'
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleAlertClose = () => {
    setAlertDialog(prev => ({ ...prev, open: false }));
  };

  const getPropertyTypeInfo = () => {
    const assetType = property?.asset_type?.toLowerCase() || '';
    const propertyType = property?.property_type?.toLowerCase() || '';

    return {
      isPlot: assetType === 'plot',
      isAgricultureLand: assetType === 'agriculture land',
      isFarmhouse: assetType === 'farm house' || assetType === 'farmhouse',
      isApartment: assetType === 'apartment',
      isIndependentHouse: assetType === 'independent house',
      isPentHouse: assetType === 'pent house' || assetType === 'penthouse',
      isStudio: assetType === 'studio',
      isVilla: assetType === 'villa',
      isCommercial: propertyType === 'commercial',
      isResidential: propertyType === 'residential',
      isRent: property?.category?.toLowerCase() === 'rent',
      isSale: property?.category?.toLowerCase() === 'sale' || property?.category?.toLowerCase() === 'sell',
      isOffice: assetType === 'office',
      isShowroom: assetType === 'showroom',
      isRetailShop: assetType === 'retail shop',
      isWarehouse: assetType === 'warehouse'
    };
  };

  if (loading) return <Loader />;

  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', flexDirection: 'column' }}>
        <Typography variant="h6" color="error" gutterBottom>
          {error}
        </Typography>
        <Button variant="contained" onClick={() => navigate('/sell-properties')}>
          Back to Properties
        </Button>
      </Box>
    );
  }

  if (!property || !editedProperty) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh', flexDirection: 'column' }}>
        <Typography variant="h6" gutterBottom>
          Property not found
        </Typography>
        <Button variant="contained" onClick={() => navigate('/sell-properties')}>
          Back to Properties
        </Button>
      </Box>
    );
  }

  const allMedia = processMedia(property?.images || []);
  const mainImageSrc = getMainImage(allMedia);
  const additionalMedia = getAdditionalMedia(allMedia);
  const remainingMediaCount = allMedia.length - 4 > 0 ? allMedia.length - 4 : 0;

  const calculateBuiltYear = () => {
    if (!hasValue(property?.age_of_property)) return null;
    const age = Number(property.age_of_property);
    if (isNaN(age) || age < 0 || age > 100) return null;
    return new Date().getFullYear() - age;
  };

  const propertyData = {
    id: property?.id,
    price: property?.category === 'rent' && hasValue(property?.monthly_rent)
      ? formatCurrency(property.monthly_rent, property.currency) + '/month'
      : formatCurrency(property?.asking_price, property?.currency),
    title: property?.property_name || '',
    location: `${property?.area_name || ''}, ${property?.location || ''}`,
    date: formatDate(property?.createdAt),
    views: property?.views || 0,
    beds: property?.bhk || 0,
    baths: property?.bathrooms || 0,
    area: `${property?.property_size || 0} ${property?.property_size_units || ''}`,
    mainImage: mainImageSrc,
    additionalMedia: additionalMedia,
    description: property?.description || 'This property is currently under verification. Update the description to provide more details about your property.',
    propertyType: `${property?.property_type || ''} - ${property?.asset_type || ''}`,
    propertyID: `#PD${(property?.id || 0).toString().padStart(6, '0')}`,
    builtYear: calculateBuiltYear(),
    status: property?.status,
    seller: property?.seller || {
      full_name: 'Owner',
      email_id: 'N/A',
      contact_number: 'N/A'
    }
  };

  const typeInfo = getPropertyTypeInfo();

  return (
    <>
      {/* Property Display Card */}
      <Card sx={{
        width: '100%',
        maxWidth: '100%',
        borderRadius: 2,
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        mb: 3,
        marginTop: { xs: '30px', md: '5px' },
      }}>
        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          height: { xs: 'auto', md: '300px' }
        }}>
          <Box sx={{
            width: { xs: '100%', md: '70%' },
            height: { xs: '200px', md: '100%' },
            position: 'relative',
            cursor: propertyData.mainImage ? 'pointer' : 'default',
            bgcolor: '#f0f0f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
                        onClick={() => propertyData.mainImage && handleMediaOpen(propertyData.mainImage, 'image', 0)}>
            {propertyData.mainImage ? (
              <CardMedia
                component="img"
                sx={{
                  height: '100%',
                  width: '100%',
                  objectFit: 'cover',
                }}
                image={propertyData.mainImage}
                alt={propertyData.title}
              />
            ) : (
              <Typography variant="body1" color="text.secondary">
                No Media
              </Typography>
            )}
            {allMedia.length > 0 && (
              <Box sx={{
                position: 'absolute',
                bottom: 10,
                right: 10,
                bgcolor: 'rgba(0,0,0,0.6)',
                color: 'white',
                px: 1,
                py: 0.5,
                borderRadius: 1,
                fontSize: '0.75rem'
              }}>
                1/{allMedia.length}
              </Box>
            )}
            <Button
              variant="contained"
              size="small"
              sx={{
                position: 'absolute',
                top: 10,
                right: 10,
                bgcolor: 'rgba(0,0,0,0.7)',
                color: 'white',
                borderRadius: 1,
                textTransform: 'none',
                '&:hover': {
                  bgcolor: 'rgba(0,0,0,0.8)',
                }
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleEditProperty('photos');
              }}
            >
              Manage Photos
            </Button>
            {propertyData.status && (
              <Box sx={{
                position: 'absolute',
                top: 10,
                left: 10,
                backgroundColor: propertyData.status === 'active' ? '#10b981' :
                  propertyData.status === 'under_verification' ? '#f59e0b' : 'rgba(0,0,0,0.7)',
                color: 'white',
                padding: '4px 10px',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: 500,
                textTransform: 'capitalize'
              }}>
                {propertyData.status.replace(/_/g, ' ')}
              </Box>
            )}
          </Box>
          <Box sx={{
            width: { xs: '100%', md: '30%' },
            height: { xs: 'auto', md: '100%' },
            display: 'flex',
            flexDirection: { xs: 'row', md: 'column' },
          }}>
            {propertyData.additionalMedia.length > 0 ? (
              propertyData.additionalMedia.map((media, index) => (
                <Box
                  key={media.id || index}
                  sx={{
                    flex: 1,
                    overflow: 'hidden',
                    borderLeft: { xs: 'none', md: '2px solid white' },
                    borderBottom: {
                      xs: 'none',
                      md: index !== propertyData.additionalMedia.length - 1 ? '2px solid white' : 'none'
                    },
                    borderRight: {
                      xs: index !== propertyData.additionalMedia.length - 1 ? '2px solid white' : 'none',
                      md: 'none'
                    },
                    height: { xs: '100px', md: 'auto' },
                    position: 'relative',
                    cursor: 'pointer'
                  }}
                  onClick={() => handleMediaOpen(media.data, media.type, index + 1)}
                >
                  <CardMedia
                    component="img"
                    image={media.data}
                    alt={`Property view ${index + 2}`}
                    sx={{
                      height: '100%',
                      width: '100%',
                      objectFit: 'cover'
                    }}
                  />
                  {index === 2 && remainingMediaCount > 0 && (
                    <Box sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '1.5rem'
                    }}>
                      +{remainingMediaCount}
                    </Box>
                  )}
                </Box>
              ))
            ) : (
              Array.from({ length: 3 }).map((_, index) => (
                <Box
                  key={`empty-${index}`}
                  sx={{
                    flex: 1,
                    backgroundColor: '#f0f0f0',
                    borderLeft: { xs: 'none', md: '2px solid white' },
                    borderBottom: {
                      xs: 'none',
                      md: index !== 2 ? '2px solid white' : 'none'
                    },
                    borderRight: {
                      xs: index !== 2 ? '2px solid white' : 'none',
                      md: 'none'
                    },
                    height: { xs: '100px', md: 'auto' },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <Typography variant="caption" color="text.secondary">
                    No Media
                  </Typography>
                </Box>
              ))
            )}
          </Box>
        </Box>

        <CardContent sx={{ p: 2 }}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1
          }}>
            <Typography variant="h5" component="div" sx={{
              fontWeight: '600',
              color: '#3366CC',
              fontFamily: 'Outfit'
            }}>
              {propertyData.price}
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 1 
            }}>
              <Button
                variant="outlined"
                startIcon={<PersonIcon sx={{ fontSize: { xs: 16, sm: 20 } }} />}
                onClick={() => setContactDialogOpen(true)}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  px: { xs: 1.5, sm: 2 },
                  py: { xs: 0.4, sm: 0.5 },
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  fontFamily: 'Outfit',
                  borderColor: '#4285F4',
                  color: '#4285F4',
                  minWidth: { xs: '120px', sm: 'auto' },
                  '&:hover': {
                    borderColor: '#3367d6',
                    backgroundColor: 'rgba(66, 133, 244, 0.04)'
                  }
                }}
              >
                Contact
              </Button>
              <Button
                variant="contained"
                onClick={() => handleEditProperty('listing')}
                sx={{
                  bgcolor: '#4285F4',
                  borderRadius: 2,
                  textTransform: 'none',
                  px: { xs: 1.5, sm: 2 },
                  py: { xs: 0.4, sm: 0.5 },
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  fontFamily: 'Outfit',
                  minWidth: { xs: '120px', sm: 'auto' },
                  '&:hover': {
                    bgcolor: '#3367d6'
                  }
                }}
              >
                Edit Listing
              </Button>
            </Box>
          </Box>

          <Typography variant="h6" component="div" sx={{
            fontWeight: '500',
            mb: 1,
            fontFamily: 'Outfit'
          }}>
            {propertyData.title}
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <LocationOnIcon sx={{
              color: 'text.secondary',
              fontSize: 18,
              mr: 0.5,
              fontWeight: '400'
            }} />
            <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
              {propertyData.location}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mr: 3 }}>
              <CalendarTodayIcon sx={{
                color: 'text.secondary',
                fontSize: 18,
                mr: 0.5,
                fontWeight: '400'
              }} />
              <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
                {propertyData.date}
              </Typography>
            </Box>
            {propertyData.views > 0 && (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <VisibilityIcon sx={{
                  color: 'text.secondary',
                  fontSize: 18,
                  mr: 0.5,
                  fontWeight: '400'
                }} />
                <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
                  {propertyData.views} {propertyData.views === 1 ? 'View' : 'Views'}
                </Typography>
              </Box>
            )}
          </Box>

          <Grid container spacing={2}>
            {hasValue(property?.bhk) && (
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <HotelIcon sx={{
                    color: 'text.secondary',
                    fontSize: 20,
                    mr: 1,
                    fontWeight: '400'
                  }} />
                  <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
                    {propertyData.beds} Beds
                  </Typography>
                </Box>
              </Grid>
            )}
            {hasValue(property?.bathrooms) && (
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <BathtubIcon sx={{
                    color: 'text.secondary',
                    fontSize: 20,
                    mr: 1,
                    fontWeight: '400'
                  }} />
                  <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
                    {propertyData.baths} Baths
                  </Typography>
                </Box>
              </Grid>
            )}
            {hasValue(property?.property_size) && (
              <Grid item xs={4}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <SquareFootIcon sx={{
                    color: 'text.secondary',
                    fontSize: 20,
                    mr: 1,
                    fontWeight: '400'
                  }} />
                  <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Outfit' }}>
                    {propertyData.area}
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>

          {/* ✅ NEW: Property Specifications Section */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" component="div" sx={{
              fontWeight: '500',
              mb: 2,
              fontFamily: 'Outfit'
            }}>
              Property Specifications
            </Typography>
            <Box sx={{
              p: 2,
              bgcolor: '#fafafa',
              borderRadius: 2,
              border: '1px solid #e0e0e0'
            }}>
              <Grid container spacing={3}>
                {/* Furnish Type */}
                {hasValue(property?.furnish_type) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                      fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Furnish Type
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px',
                      textTransform: 'capitalize'
                    }}>
                      {property.furnish_type.split('-').join(' ')}
                    </Typography>
                  </Grid>
                )}

                {/* Built-up Area */}
                {hasValue(property?.built_up_area) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                      fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Built-up Area
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px'
                    }}>
                      {property.built_up_area} {property.built_up_area_units || 'Sq.Ft'}
                    </Typography>
                  </Grid>
                )}

                {/* Carpet Area */}
                {hasValue(property?.carpet_area) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                      fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Carpet Area
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px'
                    }}>
                      {property.carpet_area} {property.carpet_area_units || 'Sq.Ft'}
                    </Typography>
                  </Grid>
                )}

                {/* UDS */}
                {hasValue(property?.uds) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                      fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      UDS
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px'
                    }}>
                      {property.uds} {property.uds_units || 'Sq.Yards'}
                    </Typography>
                  </Grid>
                )}

                {/* Zone Type */}
                {hasValue(property?.zone_type) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                      fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Zone Type
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px',
                      textTransform: 'capitalize'
                    }}>
                      {property.zone_type}
                    </Typography>
                  </Grid>
                )}

                {/* Ownership */}
                {hasValue(property?.ownership) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                      fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Ownership
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px'
                    }}>
                      {property.ownership}
                    </Typography>
                  </Grid>
                )}

                {/* Total Floors */}
                {hasValue(property?.total_floors) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                      fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Total Floors
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px'
                    }}>
                      {property.total_floors}
                    </Typography>
                  </Grid>
                )}

                {/* Selected Floor */}
                {hasValue(property?.select_floor) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                      fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Property Floor
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px'
                    }}>
                      {property.select_floor}
                    </Typography>
                  </Grid>
                )}

                {/* Hub (Commercial) */}
                {hasValue(property?.hub) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                      fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Hub
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px'
                    }}>
                      {property.hub}
                    </Typography>
                  </Grid>
                )}

                {/* Length */}
                {hasValue(property?.length) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                      fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Length
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px'
                    }}>
                      {property.length} {property.length_units || 'Feet'}
                    </Typography>
                  </Grid>
                )}

                {/* Width */}
                {hasValue(property?.width) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                      fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Width
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px'
                    }}>
                      {property.width} {property.width_units || 'Feet'}
                    </Typography>
                  </Grid>
                )}

                {/* Construction Status */}
                {hasValue(property?.construction_status) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                      fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Construction Status
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px',
                      textTransform: 'capitalize'
                    }}>
                      {property.construction_status}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Box>
          </Box>

          {hasValue(property?.description) && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" component="div" sx={{
                fontWeight: '500',
                mb: 2,
                fontFamily: 'Outfit'
              }}>
                Property Description
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{
                mb: 3,
                fontFamily: 'Outfit'
              }}>
                {propertyData.description}
              </Typography>
            </Box>
          )}

          {hasValue(property?.full_address) && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" component="div" sx={{
                fontWeight: '500',
                mb: 2,
                fontFamily: 'Outfit'
              }}>
                Complete Address
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{
                mb: 3,
                fontFamily: 'Outfit'
              }}>
                {property.full_address}
              </Typography>
            </Box>
          )}

          {hasValue(property?.youtube_link) && (
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" component="div" sx={{
                fontWeight: '500',
                mb: 2,
                fontFamily: 'Outfit'
              }}>
                Social Media Link
              </Typography>
              <Typography variant="body2" sx={{ fontFamily: 'Outfit' }}>
                <a
                  href={property.youtube_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#4285F4',
                    textDecoration: 'none',
                    fontFamily: 'Outfit'
                  }}
                >
                  {property.youtube_link}
                </a>
              </Typography>
            </Box>
          )}

          {/* Features & Amenities */}
          {shouldShowAmenities() && (
            <Box sx={{ mt: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" component="div" sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
                  Features & Amenities
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => handleEditProperty('amenities')}
                  sx={{
                    bgcolor: '#4285F4',
                    borderRadius: 2,
                    textTransform: 'none',
                    px: 2,
                    py: 0.5,
                    fontSize: '0.875rem',
                    fontFamily: 'Outfit'
                  }}
                >
                  Manage Amenities
                </Button>
              </Box>

              <Box sx={{ mt: 2 }}>
                {property?.society_aminities && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 1.5, color: '#333' }}>
                      Society Amenities
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {property.society_aminities.split(', ').filter(item => item).map((amenity, idx) => {
                        const amenityData = societyAmenitiesData.find(a => a.name === amenity);
                        return (
                          <Box
                            key={idx}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5,
                              px: 1.5,
                              py: 0.75,
                              border: '1px solid #e0e0e0',
                              borderRadius: 1,
                              backgroundColor: 'transparent'
                            }}
                          >
                            {amenityData && (
                              <Box
                                component="img"
                                src={amenityData.icon}
                                alt={amenity}
                                sx={{
                                  width: 18,
                                  height: 18,
                                  objectFit: 'contain'
                                }}
                              />
                            )}
                            <Typography sx={{
                              fontFamily: 'Outfit',
                              fontSize: '13px',
                              color: '#333',
                              fontWeight: 500
                            }}>
                              {amenity}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                )}

                {property?.furnish_facilities && (
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 1.5, color: '#333' }}>
                      Furnishing Facilities
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {property.furnish_facilities.split(', ').filter(item => item).map((facility, idx) => {
                        const facilityData = furnishingFacilitiesData.find(f => f.name === facility);
                        return (
                          <Box
                            key={idx}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5,
                              px: 1.5,
                              py: 0.75,
                              border: '1px solid #e0e0e0',
                              borderRadius: 1,
                              backgroundColor: 'transparent'
                            }}
                          >
                            {facilityData && (
                              <Box
                                component="img"
                                src={facilityData.icon}
                                alt={facility}
                                sx={{
                                  width: 18,
                                  height: 18,
                                  objectFit: 'contain'
                                }}
                              />
                            )}
                            <Typography sx={{
                              fontFamily: 'Outfit',
                              fontSize: '13px',
                              color: '#333',
                              fontWeight: 500
                            }}>
                              {facility}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                )}

                {property?.other_facilities && (
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontFamily: 'Outfit', fontWeight: 600, mb: 1.5, color: '#333' }}>
                      Other Facilities
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {property.other_facilities.split(', ').filter(item => item).map((facility, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            px: 1.5,
                            py: 0.75,
                            border: '1px solid #e0e0e0',
                            borderRadius: 1,
                            backgroundColor: 'transparent'
                          }}
                        >
                          <Typography sx={{
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            color: '#333',
                            fontWeight: 500
                          }}>
                            {facility}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          )}

          {/* Additional Details */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" component="div" sx={{
              fontWeight: '500',
              mb: 2,
              fontFamily: 'Outfit'
            }}>
              Additional details
            </Typography>
            <Box sx={{
              p: 2,
              bgcolor: '#fafafa',
              borderRadius: 2,
              border: '1px solid #e0e0e0'
            }}>
              <Grid container spacing={5}>
                <Grid item xs={6} sm={4} md={3}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    fontFamily: 'Outfit',
                    fontSize: '12px',
                    mb: 0.5
                  }}>
                    Property type
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit',
                    fontSize: '13px'
                  }}>
                    {propertyData.propertyType}
                  </Typography>
                </Grid>

                <Grid item xs={6} sm={4} md={3}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    fontFamily: 'Outfit',
                    fontSize: '12px',
                    mb: 0.5
                  }}>
                    Property ID
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit',
                    fontSize: '13px'
                  }}>
                    {propertyData.propertyID}
                  </Typography>
                </Grid>

                {hasValue(property?.negotiable) && (
                  <Grid item xs={6} sm={4} md={3}>
                    <Typography variant="body2" color="text.secondary" sx={{
                                            fontFamily: 'Outfit',
                      fontSize: '12px',
                      mb: 0.5
                    }}>
                      Price Negotiable
                    </Typography>
                    <Typography variant="body2" sx={{
                      fontWeight: '500',
                      fontFamily: 'Outfit',
                      fontSize: '13px',
                      textTransform: 'capitalize'
                    }}>
                      {property.negotiable === 'true' || property.negotiable === true ? 'Yes' : 'No'}
                    </Typography>
                  </Grid>
                )}

                <Grid item xs={6} sm={4} md={3}>
                  <Typography variant="body2" color="text.secondary" sx={{
                    fontFamily: 'Outfit',
                    fontSize: '12px',
                    mb: 0.5
                  }}>
                    Category
                  </Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: '500',
                    fontFamily: 'Outfit',
                    fontSize: '13px',
                    textTransform: 'capitalize'
                  }}>
                    {property?.category || 'Sale'}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* Contact Dialog */}
      <Dialog
        open={contactDialogOpen}
        onClose={() => setContactDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{
          fontFamily: 'Outfit',
          fontWeight: 600,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
          pb: 2
        }}>
          Contact Information
          <IconButton onClick={() => setContactDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
            <Box
              component="div"
              sx={{
                width: 60,
                height: 60,
                borderRadius: '50%',
                bgcolor: '#f0f0f0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                flexShrink: 0
              }}
            >
              <img
                src={userProfile.profile_image || "https://propertydealstalk.com/api/portraits/men/32.jpg"}
                alt="Profile"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle1" sx={{
                fontWeight: '600',
                fontFamily: 'Outfit',
                mb: 2
              }}>
                {userProfile.full_name || propertyData.seller.full_name}
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <PhoneIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1.5 }} />
                  <Typography variant="body2" sx={{ fontFamily: 'Outfit', color: '#1976d2' }}>
                    {userProfile.contact_number || propertyData.seller.contact_number}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <EmailIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1.5 }} />
                  <Typography variant="body2" sx={{
                    fontFamily: 'Outfit',
                    wordBreak: 'break-word'
                  }}>
                    {userProfile.email_id || propertyData.seller.email_id}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e0e0e0' }}>
          <Button
            onClick={() => setContactDialogOpen(false)}
            variant="contained"
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              px: 3,
              bgcolor: '#4285F4',
              fontFamily: 'Outfit'
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Media Dialog with Navigation */}
      <Dialog
        open={mediaDialogOpen}
        onClose={handleMediaClose}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent sx={{ position: 'relative', p: 0, backgroundColor: 'black' }}>
          <IconButton
            aria-label="close"
            onClick={handleMediaClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'white',
              zIndex: 10,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              }
            }}
          >
            <CloseIcon />
          </IconButton>
          <IconButton
            aria-label="previous media"
            onClick={() => handlePrevMedia(allMedia)}
            disabled={currentMediaIndex === 0}
            sx={{
              position: 'absolute',
              left: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'white',
              zIndex: 10,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
              opacity: currentMediaIndex === 0 ? 0.5 : 1,
              visibility: currentMediaIndex === 0 ? 'hidden' : 'visible',
            }}
          >
            <ChevronLeftIcon fontSize="large" />
          </IconButton>
          <IconButton
            aria-label="next media"
            onClick={() => handleNextMedia(allMedia)}
            disabled={currentMediaIndex === allMedia.length - 1}
            sx={{
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'white',
              zIndex: 10,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
              },
              opacity: currentMediaIndex === allMedia.length - 1 ? 0.5 : 1,
              visibility: currentMediaIndex === allMedia.length - 1 ? 'hidden' : 'visible',
            }}
          >
            <ChevronRightIcon fontSize="large" />
          </IconButton>
          <Box sx={{
            position: 'absolute',
            bottom: 16,
            left: '50%',
            transform: 'translateX(-50%)',
            color: 'white',
            zIndex: 10,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            padding: '4px 12px',
            borderRadius: 16,
            fontSize: '14px',
          }}>
            {currentMediaIndex + 1} / {allMedia.length}
          </Box>
          <img
            src={selectedMedia}
            alt="Property"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: '80vh',
              objectFit: 'contain'
            }}
          />
        </DialogContent>
      </Dialog>

      {/* Last Photo Warning Dialog */}
      <Dialog
        open={lastPhotoWarningOpen}
        onClose={() => setLastPhotoWarningOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{
          fontFamily: 'Outfit',
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: '#d32f2f'
        }}>
          <WarningIcon sx={{ fontSize: 28 }} />
          Cannot Delete Last Photo
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Typography sx={{
            fontFamily: 'Outfit',
            fontSize: '14px',
            color: '#666',
            mb: 2
          }}>
            At least one property image is required. You cannot delete the last remaining photo.
          </Typography>
          <Typography sx={{
            fontFamily: 'Outfit',
            fontSize: '13px',
            color: '#999',
            fontStyle: 'italic'
          }}>
            Please upload additional images before deleting this one.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setLastPhotoWarningOpen(false)}
            variant="contained"
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              px: 3,
              bgcolor: '#4285F4',
              fontFamily: 'Outfit',
              '&:hover': {
                bgcolor: '#3367d6'
              }
            }}
          >
            OK, I Understand
          </Button>
        </DialogActions>
      </Dialog>

      {/* Photos Management Dialog */}
      <Dialog
        open={photosDialogOpen}
        onClose={() => setPhotosDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{
          fontFamily: 'Outfit',
          fontWeight: 600,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
          pb: 2
        }}>
          Manage Property Photos
          <IconButton onClick={() => setPhotosDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box>
            <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                component="label"
                startIcon={<AddPhotoAlternateIcon />}
                sx={{
                  bgcolor: '#4285F4',
                  borderRadius: 2,
                  textTransform: 'none',
                  px: 3,
                  py: 1,
                  fontSize: '0.875rem',
                  fontFamily: 'Outfit'
                }}
                disabled={uploadedPhotos.length >= 10}
              >
                Add Photos
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  multiple
                  onChange={(e) => handleFileUpload(e)}
                />
              </Button>
            </Box>
            {uploadedPhotos.length >= 10 && (
              <Typography
                variant="caption"
                color="error"
                align="center"
                sx={{ display: 'block', mb: 2, fontFamily: 'Outfit' }}
              >
                Maximum limit of 10 images reached
              </Typography>
            )}
            <Grid container spacing={2}>
              {uploadedPhotos.map((photo) => (
                <Grid item xs={12} sm={6} md={4} key={photo.id}>
                  <Box sx={{
                    position: 'relative',
                    borderRadius: 2,
                    overflow: 'hidden',
                    height: 180
                  }}>
                    <img
                      src={photo.preview}
                      alt={photo.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        bgcolor: 'rgba(0,0,0,0.5)',
                        color: 'white',
                        '&:hover': {
                          bgcolor: 'rgba(0,0,0,0.7)'
                        }
                      }}
                      onClick={() => handleDeleteMedia(photo.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                    {photo.isNew && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 8,
                          left: 8,
                          backgroundColor: '#4285F4',
                          color: 'white',
                          fontSize: '10px',
                          px: 1,
                          py: 0.5,
                          borderRadius: 1,
                          fontFamily: 'Outfit'
                        }}
                      >
                        New
                      </Box>
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
            {uploadedPhotos.length === 0 && (
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: '#f5f5f5',
                borderRadius: 2,
                p: 4,
                mt: 2
              }}>
                <Typography variant="body1" color="text.secondary" align="center" sx={{ fontFamily: 'Outfit' }}>
                  No photos uploaded yet. Click "Add Photos" to upload property images.
                </Typography>
                <Typography variant="caption" color="text.secondary" align="center" sx={{ mt: 1, fontFamily: 'Outfit' }}>
                  Maximum 10 images allowed. Backend handles file size validation.
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e0e0e0' }}>
          <Button
            onClick={() => setPhotosDialogOpen(false)}
            variant="outlined"
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              px: 3,
              fontFamily: 'Outfit'
            }}
            disabled={isUploading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveMedia}
            variant="contained"
            color="primary"
            disabled={isUploading || (uploadedPhotos.filter(p => p.isNew).length === 0 && imagesToDelete.length === 0)}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              px: 3,
              bgcolor: '#4285F4',
              fontFamily: 'Outfit',
              '&:hover': {
                bgcolor: '#3367d6',
              }
            }}
          >
            {isUploading ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={20} sx={{ color: 'white' }} />
                <span>Saving...</span>
              </Box>
            ) : (
              'Save Photos'
            )}
          </Button>
        </DialogActions>
        {isUploading && <Loader />}
      </Dialog>

      {/* Edit Listing Dialog with 2 Tabs */}
      <Dialog
        open={editListingDialogOpen}
        onClose={() => setEditListingDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: '90vh',
            height: '90vh'
          }
        }}
      >
        <DialogTitle sx={{
          fontFamily: 'Outfit',
          fontWeight: 600,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
          pb: 2
        }}>
          Edit Property Listing
          <IconButton onClick={() => setEditListingDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3 }}>
          <Tabs 
            value={currentTab} 
            onChange={(e, newValue) => setCurrentTab(newValue)}
            sx={{
              '& .MuiTab-root': {
                fontFamily: 'Outfit',
                textTransform: 'none',
                fontSize: '14px'
              }
            }}
          >
            <Tab label="Property Details" />
            <Tab label={typeInfo.isRent ? "Rent Details" : "Price Details"} />
          </Tabs>
        </Box>

        <DialogContent sx={{ pt: 3, overflow: 'auto' }}>
          {currentTab === 0 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {typeInfo.isCommercial ? (
                <EditCommercial 
                  editedProperty={editedProperty}
                  handleInputChange={handleInputChange}
                  typeInfo={typeInfo}
                />
              ) : (
                <EditResidential 
                  editedProperty={editedProperty}
                  handleInputChange={handleInputChange}
                  typeInfo={typeInfo}
                />
              )}
            </Box>
          )}

          {currentTab === 1 && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {typeInfo.isRent ? (
                <>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                        Monthly Rent <span style={{ color: '#d32f2f' }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        name="monthly_rent"
                        type="number"
                        value={editedProperty?.monthly_rent || ''}
                        onChange={handleInputChange}
                        placeholder="Enter amount"
                        size="small"
                        InputProps={{
                          startAdornment: <InputAdornment position="start">₹</InputAdornment>
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                        Available from <span style={{ color: '#d32f2f' }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        name="available_from"
                        type="date"
                        value={editedProperty?.available_from ? editedProperty.available_from.split('T')[0] : ''}
                        onChange={handleInputChange}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                        Security Deposit <span style={{ color: '#d32f2f' }}>*</span>
                      </Typography>
                      <FormControl fullWidth size="small">
                        <Select
                          name="security_deposit"
                          value={editedProperty?.security_deposit || ''}
                          onChange={handleInputChange}
                          displayEmpty
                          sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                        >
                          <MenuItem value="" disabled>Select Security Deposit</MenuItem>
                          <MenuItem value="none">None</MenuItem>
                          <MenuItem value="1month">1 Month</MenuItem>
                          <MenuItem value="2month">2 Months</MenuItem>
                          <MenuItem value="custom">Custom</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                        Property Cost <span style={{ color: '#d32f2f' }}>*</span>
                      </Typography>
                      <TextField
                        fullWidth
                        name="asking_price"
                        type="number"
                        value={editedProperty?.asking_price || ''}
                        onChange={handleInputChange}
                        placeholder="Enter amount"
                        size="small"
                        InputProps={{
                          startAdornment: <InputAdornment position="start">₹</InputAdornment>
                        }}
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                        Construction Status <span style={{ color: '#d32f2f' }}>*</span>
                      </Typography>
                      <FormControl fullWidth size="small">
                        <Select
                          name="construction_status"
                          value={editedProperty?.construction_status || ''}
                          onChange={handleInputChange}
                          displayEmpty
                          sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                        >
                          <MenuItem value="" disabled>Select Status</MenuItem>
                          <MenuItem value="ready to move">Ready to Move</MenuItem>
                          <MenuItem value="under construction">Under Construction</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                        Price Negotiable? <span style={{ color: '#d32f2f' }}>*</span>
                      </Typography>
                      <FormControl fullWidth size="small">
                        <Select
                          name="negotiable"
                          value={editedProperty?.negotiable === true || editedProperty?.negotiable === 'true' ? 'true' : 'false'}
                          onChange={handleInputChange}
                          sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                        >
                          <MenuItem value="true">Yes</MenuItem>
                          <MenuItem value="false">No</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid #e0e0e0', justifyContent: 'space-between' }}>
          <Button
            onClick={() => setEditListingDialogOpen(false)}
            variant="outlined"
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              px: 3,
              fontFamily: 'Outfit'
            }}
            disabled={isSaving}
          >
            Cancel
          </Button>

          <Box sx={{ display: 'flex', gap: 2 }}>
            {currentTab > 0 && (
              <Button
                onClick={() => setCurrentTab(prev => prev - 1)}
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  px: 3,
                  fontFamily: 'Outfit'
                }}
                disabled={isSaving}
              >
                Back
              </Button>
            )}

            {currentTab < 1 ? (
              <Button
                onClick={() => setCurrentTab(prev => prev + 1)}
                variant="contained"
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  px: 3,
                  fontFamily: 'Outfit',
                  bgcolor: '#4285F4',
                  '&:hover': {
                    bgcolor: '#3367d6',
                  }
                }}
              >
                Next
              </Button>
            ) : (
              <Button
                onClick={() => handleSaveChanges('listing')}
                variant="contained"
                color="primary"
                disabled={isSaving}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  px: 3,
                  fontFamily: 'Outfit',
                  bgcolor: '#4285F4',
                  '&:hover': {
                    bgcolor: '#3367d6',
                  }
                }}
              >
                {isSaving ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={20} sx={{ color: 'white' }} />
                    <span>Saving...</span>
                  </Box>
                ) : (
                  'Save Changes'
                )}
              </Button>
            )}
          </Box>
        </DialogActions>
      </Dialog>

      {/* Manage Amenities Dialog */}
      <Dialog
        open={amenitiesDialogOpen}
        onClose={() => setAmenitiesDialogOpen(false)}
        maxWidth="lg"
        fullWidth
        fullScreen={window.innerWidth < 600}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: window.innerWidth < 600 ? 0 : '16px',
            maxHeight: window.innerWidth < 600 ? '100vh' : '90vh',
            margin: window.innerWidth < 600 ? 0 : 2,
          }
        }}
      >
        <DialogTitle sx={{
          fontFamily: 'Outfit',
          fontWeight: 600,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
          pb: 2,
          px: window.innerWidth < 600 ? 2 : 3
        }}>
          Manage Property Amenities
          <IconButton onClick={() => setAmenitiesDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ 
          pt: 3, 
          pb: window.innerWidth < 600 ? 10 : 3,
          px: window.innerWidth < 600 ? 2 : 3 
        }}>
          <Box>
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h6"
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 500,
                  color: '#333',
                  mb: 2,
                  fontSize: window.innerWidth < 600 ? '16px' : '18px'
                }}
              >
                Society Amenities
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  multiple
                  value={editedProperty?.society_aminities ? editedProperty.society_aminities.split(', ').filter(item => item) : []}
                  onChange={(e) => {
                    const value = e.target.value;
                    setEditedProperty(prev => ({
                      ...prev,
                      society_aminities: typeof value === 'string' ? value : value.join(', ')
                    }));
                  }}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {selected.map((value) => {
                        const amenity = societyAmenitiesData.find(a => a.name === value);
                        return (
                          <Box 
                            key={value}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5,
                              px: 1,
                              py: 0.5,
                              border: '1px solid #e0e0e0',
                              borderRadius: 1,
                              backgroundColor: 'transparent'
                            }}
                          >
                            {amenity && (
                              <Box
                                component="img"
                                src={amenity.icon}
                                alt={value}
                                sx={{
                                  width: 16,
                                  height: 16,
                                  objectFit: 'contain'
                                }}
                              />
                            )}
                            <Typography sx={{ 
                              fontFamily: 'Outfit', 
                              fontSize: '12px',
                              color: '#333'
                            }}>
                              {value}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                  sx={{ 
                    borderRadius: 1.5, 
                    fontFamily: 'Outfit', 
                    fontSize: '13px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#e0e0e0'
                    }
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 400,
                      },
                    },
                  }}
                >
                  {societyAmenitiesData.map((amenity) => (
                    <MenuItem 
                      key={amenity.name} 
                      value={amenity.name}
                      sx={{
                                               fontFamily: 'Outfit',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        py: 1.5,
                        backgroundColor: editedProperty?.society_aminities?.split(', ').includes(amenity.name) ? '#f5f5f5' : 'transparent',
                        '&:hover': {
                          backgroundColor: '#f0f0f0'
                        }
                      }}
                    >
                      <Box
                        component="img"
                        src={amenity.icon}
                        alt={amenity.name}
                        sx={{
                          width: 24,
                          height: 24,
                          objectFit: 'contain'
                        }}
                      />
                      <Typography sx={{ fontFamily: 'Outfit', fontSize: '14px', flex: 1 }}>
                        {amenity.name}
                      </Typography>
                      {editedProperty?.society_aminities?.split(', ').includes(amenity.name) && (
                        <CheckIcon sx={{ color: '#4285F4', fontSize: 20 }} />
                      )}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h6"
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 500,
                  color: '#333',
                  mb: 2,
                  fontSize: window.innerWidth < 600 ? '16px' : '18px'
                }}
              >
                Furnishing Facilities
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  multiple
                  value={editedProperty?.furnish_facilities ? editedProperty.furnish_facilities.split(', ').filter(item => item) : []}
                  onChange={(e) => {
                    const value = e.target.value;
                    setEditedProperty(prev => ({
                      ...prev,
                      furnish_facilities: typeof value === 'string' ? value : value.join(', ')
                    }));
                  }}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {selected.map((value) => {
                        const facility = furnishingFacilitiesData.find(f => f.name === value);
                        return (
                          <Box 
                            key={value}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5,
                              px: 1,
                              py: 0.5,
                              border: '1px solid #e0e0e0',
                              borderRadius: 1,
                              backgroundColor: 'transparent'
                            }}
                          >
                            {facility && (
                              <Box
                                component="img"
                                src={facility.icon}
                                alt={value}
                                sx={{
                                  width: 16,
                                  height: 16,
                                  objectFit: 'contain'
                                }}
                              />
                            )}
                            <Typography sx={{ 
                              fontFamily: 'Outfit', 
                              fontSize: '12px',
                              color: '#333'
                            }}>
                              {value}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                  sx={{ 
                    borderRadius: 1.5, 
                    fontFamily: 'Outfit', 
                    fontSize: '13px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#e0e0e0'
                    }
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 400,
                      },
                    },
                  }}
                >
                  {furnishingFacilitiesData.map((facility) => (
                    <MenuItem 
                      key={facility.name} 
                      value={facility.name}
                      sx={{
                        fontFamily: 'Outfit',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        py: 1.5,
                        backgroundColor: editedProperty?.furnish_facilities?.split(', ').includes(facility.name) ? '#f5f5f5' : 'transparent',
                        '&:hover': {
                          backgroundColor: '#f0f0f0'
                        }
                      }}
                    >
                      <Box
                        component="img"
                        src={facility.icon}
                        alt={facility.name}
                        sx={{
                          width: 24,
                          height: 24,
                          objectFit: 'contain'
                        }}
                      />
                      <Typography sx={{ fontFamily: 'Outfit', fontSize: '14px', flex: 1 }}>
                        {facility.name}
                      </Typography>
                      {editedProperty?.furnish_facilities?.split(', ').includes(facility.name) && (
                        <CheckIcon sx={{ color: '#4285F4', fontSize: 20 }} />
                      )}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h6"
                sx={{
                  fontFamily: 'Outfit',
                  fontWeight: 500,
                  color: '#333',
                  mb: 2,
                  fontSize: window.innerWidth < 600 ? '16px' : '18px'
                }}
              >
                Other Facilities
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  multiple
                  value={editedProperty?.other_facilities ? editedProperty.other_facilities.split(', ').filter(item => item) : []}
                  onChange={(e) => {
                    const value = e.target.value;
                    setEditedProperty(prev => ({
                      ...prev,
                      other_facilities: typeof value === 'string' ? value : value.join(', ')
                    }));
                  }}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {selected.map((value) => (
                        <Box 
                          key={value}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            px: 1,
                            py: 0.5,
                            border: '1px solid #e0e0e0',
                            borderRadius: 1,
                            backgroundColor: 'transparent'
                          }}
                        >
                          <Typography sx={{ 
                            fontFamily: 'Outfit', 
                            fontSize: '12px',
                            color: '#333'
                          }}>
                            {value}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  )}
                  sx={{ 
                    borderRadius: 1.5, 
                    fontFamily: 'Outfit', 
                    fontSize: '13px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#e0e0e0'
                    }
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 400,
                      },
                    },
                  }}
                >
                  {otherFacilitiesData.map((facility) => (
                    <MenuItem 
                      key={facility} 
                      value={facility}
                      sx={{
                        fontFamily: 'Outfit',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        py: 1.5,
                        backgroundColor: editedProperty?.other_facilities?.split(', ').includes(facility) ? '#f5f5f5' : 'transparent',
                        '&:hover': {
                          backgroundColor: '#f0f0f0'
                        }
                      }}
                    >
                      <Typography sx={{ fontFamily: 'Outfit', fontSize: '14px' }}>
                        {facility}
                      </Typography>
                      {editedProperty?.other_facilities?.split(', ').includes(facility) && (
                        <CheckIcon sx={{ color: '#4285F4', fontSize: 20 }} />
                      )}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{
          p: window.innerWidth < 600 ? 2 : 3,
          justifyContent: 'space-between',
          borderTop: '1px solid #e0e0e0',
          position: window.innerWidth < 600 ? 'fixed' : 'relative',
          bottom: window.innerWidth < 600 ? 0 : 'auto',
          left: window.innerWidth < 600 ? 0 : 'auto',
          right: window.innerWidth < 600 ? 0 : 'auto',
          backgroundColor: 'white',
          gap: 2
        }}>
          <Button
            onClick={() => {
              setAmenitiesDialogOpen(false);
            }}
            variant="outlined"
            sx={{
              flex: window.innerWidth < 600 ? 1 : 'none',
              height: window.innerWidth < 600 ? 48 : 'auto',
              borderRadius: 2,
              textTransform: 'none',
              px: 3,
              fontFamily: 'Outfit',
              borderColor: '#e0e0e0',
              color: '#666',
              '&:hover': {
                borderColor: '#4285F4',
                backgroundColor: 'transparent'
              }
            }}
            disabled={isSaving}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleSaveChanges('amenities')}
            variant="contained"
            disabled={isSaving}
            sx={{
              flex: window.innerWidth < 600 ? 1 : 'none',
              height: window.innerWidth < 600 ? 48 : 'auto',
              borderRadius: 2,
              textTransform: 'none',
              px: 3,
              fontFamily: 'Outfit',
              bgcolor: '#4285F4',
              '&:hover': {
                bgcolor: '#3367d6'
              }
            }}
          >
            {isSaving ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={20} sx={{ color: 'white' }} />
                <span>Saving...</span>
              </Box>
            ) : (
              'Save Amenities'
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Alert Snackbar */}
      <Snackbar
        open={alertDialog.open}
        autoHideDuration={4000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleAlertClose} 
          severity={alertDialog.severity}
          sx={{ 
            width: '100%',
            fontFamily: 'Outfit',
            fontSize: '13px'
          }}
        >
          {alertDialog.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default EditProperties;









